var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "viewBox": "8.2754 12.4266 484.5432 310.303",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "transform": "matrix(0.7148120403289795, 0, 0, 0.7148120403289795, -17.128992080688477, -16.451345443725586)"
    }
  }, [_c('g', [_c('circle', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "cx": "530.312",
      "cy": "186.3",
      "r": "34.351"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M520.555,186.768v-13.183c0-2.303,2.493-3.742,4.487-2.59l11.416,6.591l11.416,6.591 c1.994,1.151,1.994,4.03,0,5.181l-11.416,6.591l-11.416,6.591c-1.994,1.151-4.487-0.288-4.487-2.59V186.768z"
    }
  })])]), _c('g', {
    attrs: {
      "transform": "matrix(0.7148120403289795, 0, 0, 0.7148120403289795, -17.128992080688477, -16.451345443725586)"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#f5f5f5"
    },
    attrs: {
      "d": "M51.487,447.923c-1.25-1.072-4.037-4.467-1.888-8.417c0.788-1.448,2.462-2.164,3.977-2.802 c1.515-0.638,3.107-1.192,4.361-2.259c2.364-2.012,3.017-5.353,4.586-8.037c1.802-3.08,5.165-5.388,8.717-5.227 c4.069,0.185,7.462,3.508,9,7.297c1.538,3.789,1.592,7.996,1.624,12.088c0.018,2.262-0.083,4.813-1.744,6.341 c-1.531,1.409-3.837,1.426-5.913,1.362c-7.411-0.228-14.823-0.455-22.235-0.683"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M94.014,386.781H35.54l10.533,62.807c0.46,2.743,2.445,4.857,4.992,5.592 c0.067,0.021,0.137,0.037,0.205,0.056c0.174,0.045,0.342,0.103,0.521,0.135c0.385,0.08,0.784,0.12,1.189,0.137 c0.003,0.02,0.007,0.041,0.009,0.06l0.285-0.045c0.001,0,0.001,0,0.002,0h26.061c0.49,0,0.969-0.051,1.432-0.143 c3.078-0.476,5.541-2.946,5.916-6.139l5.078-43.275l0.229-1.721h-0.027l2.011-17.138L94.014,386.781z M82.983,426.844h-6.001 l0.605-18.228h6.953L82.983,426.844z M85.122,408.616h5.745l-2.139,18.228h-5.164L85.122,408.616z M67.979,447.051 l-0.365-15.835h8.642l-0.526,15.835H67.979z M58.637,431.216h8.397l0.365,15.835h-7.531L58.637,431.216z M59.285,447.051 h-7.04c-0.669-4.275-1.54-9.832-2.482-15.835h8.291L59.285,447.051z M58.297,426.844l-1.417-18.228h9.633l0.42,18.228H58.297 z M67.513,426.844l-0.42-18.228h9.913l-0.606,18.228H67.513z M66.993,404.245l-0.389-16.881h11.108l-0.561,16.881H66.993z M66.412,404.245h-9.872l-1.312-16.881h10.795L66.412,404.245z M55.959,404.245H45.514c-0.37-2.331-0.72-4.538-1.037-6.524 c-1.09-6.825-1.499-9.391-1.726-10.357h11.896L55.959,404.245z M56.299,408.616l1.417,18.228h-8.638 c-0.291-1.85-0.585-3.72-0.879-5.593c-0.677-4.303-1.355-8.604-1.992-12.635H56.299z M48.49,426.844h-5.643l-3.057-18.228 h5.828C46.509,414.25,47.496,420.519,48.49,426.844z M49.177,431.216c0.86,5.48,1.707,10.883,2.481,15.835h-5.422 l-2.656-15.835H49.177z M76.311,447.051l0.526-15.835h5.773l-1.353,15.835H76.311z M77.732,404.245l0.561-16.881h8.062 l-1.442,16.881H77.732z M42.197,387.364c0.232,1.221,1.299,7.863,2.729,16.881h-5.869l-2.831-16.881H42.197z M86.358,447.051 h-4.519l1.353-15.835h5.024L86.358,447.051z M91.38,404.245h-5.884l1.442-16.881h6.423L91.38,404.245z"
    }
  })])])])])])]), _c('g', {
    attrs: {
      "transform": "matrix(0.7148120403289795, 0, 0, 0.7148120403289795, -17.128992080688477, -16.451345443725586)"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#fafafa"
    },
    attrs: {
      "x": "58.115",
      "y": "47.818",
      "width": "117.987",
      "height": "105.558"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M176.102,153.376c0,0-0.02-0.677-0.03-1.959c-0.007-1.295-0.017-3.189-0.031-5.656 c-0.016-4.956-0.039-12.2-0.069-21.427c-0.033-18.444-0.08-44.798-0.138-76.516l0.267,0.267 c-33.979,0.014-74.531,0.03-117.976,0.048h-0.011l0.315-0.315c-0.014,38.403-0.027,74.541-0.038,105.558l-0.278-0.278 c35.198,0.058,64.658,0.106,85.337,0.14c10.346,0.032,18.492,0.056,24.069,0.073c2.778,0.014,4.913,0.025,6.372,0.033 c0.714,0.007,1.259,0.012,1.643,0.016C175.905,153.365,176.102,153.376,176.102,153.376s-0.175,0.01-0.535,0.016 c-0.377,0.004-0.912,0.009-1.613,0.016c-1.446,0.008-3.563,0.018-6.318,0.033c-5.563,0.017-13.687,0.042-24.006,0.073 c-20.722,0.034-50.244,0.082-85.515,0.14l-0.278,0.001v-0.278c-0.011-31.017-0.024-67.154-0.038-105.558v-0.316h0.316h0.011 c43.445,0.018,83.997,0.034,117.976,0.048h0.268l-0.001,0.268c-0.057,31.788-0.104,58.201-0.138,76.685 c-0.03,9.201-0.053,16.425-0.069,21.367c-0.014,2.445-0.024,4.321-0.031,5.605 C176.122,152.739,176.102,153.376,176.102,153.376z"
    }
  })])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M103.355,66.573c0,0.174-6.21,0.315-13.869,0.315c-7.662,0-13.871-0.141-13.871-0.315 c0-0.174,6.209-0.315,13.871-0.315C97.145,66.258,103.355,66.399,103.355,66.573z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M153.348,74.499c0,0.174-17.061,0.315-38.102,0.315c-21.049,0-38.106-0.141-38.106-0.315 c0-0.174,17.058-0.315,38.106-0.315C136.287,74.184,153.348,74.325,153.348,74.499z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "75.818",
      "y": "87.925",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "88.054",
      "y": "87.925",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "100.516",
      "y": "87.699",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "112.525",
      "y": "87.925",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "124.761",
      "y": "87.925",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "136.997",
      "y": "87.925",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ebebeb"
    },
    attrs: {
      "x": "149.233",
      "y": "87.925",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ebebeb"
    },
    attrs: {
      "x": "75.818",
      "y": "98.492",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "88.054",
      "y": "98.492",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ebebeb"
    },
    attrs: {
      "x": "100.29",
      "y": "98.492",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "112.525",
      "y": "98.492",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "124.761",
      "y": "98.492",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "137.223",
      "y": "98.267",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "149.233",
      "y": "98.492",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "75.818",
      "y": "109.06",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "88.28",
      "y": "108.834",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "100.29",
      "y": "109.06",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ebebeb"
    },
    attrs: {
      "x": "112.525",
      "y": "109.06",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "124.761",
      "y": "109.06",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "136.997",
      "y": "109.06",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "149.233",
      "y": "109.06",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "75.818",
      "y": "119.627",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "88.054",
      "y": "119.627",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "100.29",
      "y": "119.627",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "112.751",
      "y": "119.402",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "124.761",
      "y": "119.627",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ebebeb"
    },
    attrs: {
      "x": "136.997",
      "y": "119.627",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "149.233",
      "y": "119.627",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "75.818",
      "y": "130.195",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ebebeb"
    },
    attrs: {
      "x": "88.054",
      "y": "130.195",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "100.29",
      "y": "130.195",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "112.525",
      "y": "130.195",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "124.761",
      "y": "130.195",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "137.223",
      "y": "129.969",
      "width": "4.971",
      "height": "4.971"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "149.233",
      "y": "130.195",
      "width": "4.971",
      "height": "4.971"
    }
  })])])])]), _c('g', {
    attrs: {
      "transform": "matrix(0.7148120403289795, 0, 0, 0.7148120403289795, -17.128992080688477, -16.451345443725586)"
    }
  }, [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "619.693",
      "y": "40.401",
      "width": "90.36",
      "height": "130.973"
    }
  })])]), _c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#f5f5f5"
    },
    attrs: {
      "x": "615.166",
      "y": "40.401",
      "width": "90.36",
      "height": "130.973"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "x": "626.392",
      "y": "54.586",
      "width": "67.907",
      "height": "102.602"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M694.299,157.189c0,0-0.009-0.174-0.013-0.502c-0.003-0.339-0.008-0.822-0.013-1.455 c-0.006-1.289-0.015-3.177-0.027-5.628c-0.014-4.917-0.035-12.083-0.061-21.135c-0.027-18.092-0.066-43.712-0.111-73.882 l0.225,0.225c-20.747,0.006-43.736,0.013-67.898,0.02h-0.008l0.246-0.246c-0.019,38.706-0.036,74.393-0.05,102.602 l-0.196-0.196c20.68,0.043,37.631,0.078,49.427,0.103c5.9,0.021,10.508,0.038,13.656,0.05c1.564,0.01,2.763,0.017,3.584,0.022 C693.871,157.175,694.299,157.189,694.299,157.189s-0.4,0.014-1.198,0.021c-0.813,0.005-2,0.012-3.548,0.022 c-3.137,0.011-7.73,0.028-13.612,0.05c-11.825,0.025-28.818,0.06-49.549,0.103l-0.196,0l0-0.196 c-0.014-28.209-0.031-63.896-0.05-102.602l0-0.246h0.246h0.008c24.162,0.007,47.152,0.014,67.898,0.02h0.226l0,0.225 c-0.045,30.231-0.084,55.902-0.111,74.03c-0.026,9.03-0.047,16.179-0.061,21.084c-0.012,2.431-0.021,4.304-0.027,5.583 c-0.006,0.622-0.01,1.097-0.013,1.43C694.308,157.033,694.299,157.189,694.299,157.189z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "none",
      "stroke": "#fbfbfb",
      "stroke-width": "0.25",
      "stroke-miterlimit": "10"
    },
    attrs: {
      "d": "M691.151,55.271"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M705.779,40.401c0.053,0.041-0.561,0.936-1.611,2.34c-1.05,1.404-2.539,3.313-4.24,5.378 c-1.701,2.065-3.29,3.893-4.466,5.192c-1.177,1.299-1.938,2.073-1.988,2.029c-0.052-0.045,0.616-0.9,1.724-2.256 c1.211-1.47,2.702-3.278,4.35-5.278c1.647-2,3.136-3.81,4.346-5.28C705.014,41.179,705.725,40.359,705.779,40.401z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M694.645,156.858c3.373,5.363,7.354,10.343,11.844,14.813"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M706.489,171.671c-0.044,0.045-0.851-0.654-2.065-1.878c-1.214-1.223-2.823-2.984-4.468-5.039 c-1.643-2.057-3.007-4.014-3.933-5.468c-0.927-1.454-1.432-2.394-1.378-2.427c0.061-0.038,0.669,0.835,1.666,2.233 c0.996,1.398,2.396,3.311,4.029,5.356c1.635,2.043,3.192,3.829,4.337,5.108C705.822,170.834,706.54,171.619,706.489,171.671z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M615.153,171.27c3.945-4.868,7.89-9.735,11.836-14.603"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M626.989,156.667c0.105,0.085-2.459,3.424-5.727,7.456c-3.269,4.033-6.004,7.233-6.109,7.147 c-0.105-0.085,2.458-3.423,5.727-7.456C624.148,159.782,626.883,156.582,626.989,156.667z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M615.166,40.401c0.106-0.084,2.679,2.991,5.745,6.867c3.067,3.878,5.466,7.089,5.36,7.173 c-0.106,0.084-2.678-2.99-5.745-6.868C617.459,43.697,615.06,40.485,615.166,40.401z"
    }
  })])])]), _c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "650.404",
      "y": "75.419",
      "width": "22.738",
      "height": "64.559"
    }
  })])])]), _c('g', {
    attrs: {
      "transform": "matrix(0.7148120403289795, 0, 0, 0.7148120403289795, -17.128992080688477, -16.451345443725586)"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M192.462,357.13c-4.499-2.825-9.653-4.599-14.938-5.142c-2.441-0.251-5.108-0.18-7.066,1.299 c-0.415,0.314-0.821,0.778-0.728,1.29c0.068,0.377,0.387,0.65,0.691,0.883C176.499,360.098,185.693,360.683,192.462,357.13"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M192.078,356.708c-3.382-2.639-6.783-5.296-9.648-8.489c-2.865-3.193-5.193-6.983-6.049-11.187 c-0.259-1.275-0.34-2.732,0.478-3.743C184.55,339.295,190.591,347.063,192.078,356.708"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M192.382,357.073c-0.579-4.207-0.787-8.532,0.179-12.668c0.966-4.135,3.216-8.094,6.747-10.453 c1.329,3.106,0.758,6.685-0.178,9.931c-1.447,5.017-3.716,9.795-6.691,14.087"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M199.921,370.582c-4.577,0.556-8.563,2.969-11.98,6.063c-3.417,3.095-5.846,7.264-6.852,11.763 c4.489-0.277,8.297-3.443,11.06-6.993c2.762-3.549,4.676-7.444,7.71-10.764"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M201.559,372.742c-3.686-9.08-2.351-20.021,3.412-27.948 C207.578,354.069,206.62,364.545,201.559,372.742"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M211.52,384.603c-4.153-0.258-8.376,0.732-11.983,2.808c-3.607,2.076-6.583,5.231-8.446,8.952 c-0.253,0.506-0.477,1.149-0.138,1.602c0.294,0.394,0.864,0.43,1.355,0.398c4.026-0.261,7.594-2.683,10.539-5.441 c2.944-2.758,5.509-5.945,8.763-8.33"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M211.202,383.958c-2.143-6.856-2.276-14.326-0.38-21.254c0.749-2.736,2.006-5.616,4.536-6.899 c0.216-0.109,0.467-0.207,0.694-0.122c0.215,0.081,0.339,0.301,0.438,0.508c0.9,1.88,1.162,4.015,1.069,6.097 c-0.093,2.083-0.525,4.133-0.955,6.173c-0.797,3.773-1.221,7.827-3.29,11.081c-0.491,0.772-0.924,1.606-1.316,2.434 c-0.392,0.827-0.395,1.118-0.754,1.776"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M237.57,387.886c-1.953-7.431,0.12-16.44,4.803-22.532c0.345-0.449,0.802-0.929,1.365-0.877 c0.862,0.08,1.086,1.229,1.047,2.094C244.447,374.165,241.914,381.648,237.57,387.886"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M239.948,389.511c9.028,2.349,19.386,0.066,26.894-5.47c-4.45-2.255-9.696-2.899-14.559-1.787 C247.42,383.367,242.975,385.546,239.948,389.511"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M241.953,384.563c5.057-8.244,14.75-13.624,24.409-14.114c-1.113,3.928-4.341,6.982-7.983,8.827 c-3.643,1.845-7.708,2.648-11.717,3.427C245.102,383.005,242.963,383.338,241.953,384.563"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M238.073,360.554c1.369-4.691,2.746-9.423,3.122-14.295c0.376-4.872-0.319-9.958-2.847-14.14 c-4.723,9.139-5.201,19.818-0.416,28.925"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M253.974,352.517c5.523-10.038,16.792-18.057,28.194-19.181 C277.77,344.289,265.775,352.753,253.974,352.517"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M250.5,354.484c8.237,1.255,15.255,6.516,22.953,9.705c1.646,0.682,3.422,1.225,5.189,0.994 c1.767-0.232,3.51-1.417,3.906-3.154c0.329-1.443-0.328-2.974-1.363-4.032c-1.035-1.057-2.403-1.717-3.769-2.286 c-8.384-3.491-17.376-3.578-26.207-1.461"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M245.733,360.262c1.865,0.534,2.502,1.5,3.979,2.757c5.01,4.267,11.019,7.354,17.406,8.941 c0.665,0.165,1.537,0.231,1.867-0.37c0.288-0.525-0.076-1.16-0.45-1.628c-2.676-3.348-6.493-5.638-10.509-7.134 c-4.017-1.496-7.497-3.299-12.292-2.912"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M240.354,325.368c6.698,6.252,16.133,9.462,25.254,8.592c0.415-0.039,0.867-0.106,1.15-0.413 c0.635-0.691-0.127-1.759-0.868-2.336C258.465,325.422,249.472,323.022,240.354,325.368"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M246.731,323.034c8.854-6.638,20.996-8.642,31.513-5.2c-3.969,3.911-9.475,6.015-15.017,6.593 C257.686,325.004,252.136,324.389,246.731,323.034"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M244.197,307c-0.729-7.411-0.256-13.261-0.77-20.707c-0.041-0.595-0.169-1.311-0.725-1.525 c-0.775-0.298-1.421,0.654-1.675,1.444c-2.207,6.864-1.001,14.736,3.16,20.624"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M243.663,307.818c5.023-3.106,8.791-7.163,12.276-11.931c2.425-3.318,4.469-7.292,3.918-11.365 c-3.405-0.068-6.641,1.81-8.855,4.397c-2.215,2.587-3.531,5.822-4.514,9.082C245.505,301.263,244.817,304.614,243.663,307.818"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M255.725,304.467c11.024-4.077,21.309-10.141,30.212-17.814 c-3.609-1.454-7.741-0.584-11.349,0.873c-8.243,3.327-14.978,8.944-19.021,16.861"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M247.055,311.873c5.577,0.61,11.242,1.007,16.776,0.082c5.439-0.909,10.579-3.065,15.661-5.204 c0.421-0.177,0.879-0.39,1.064-0.808c0.2-0.454-0.013-1.007-0.381-1.34c-0.368-0.333-0.858-0.492-1.336-0.626 c-5.525-1.545-11.488-0.822-16.925,1.011C256.478,306.822,252.02,308.999,247.055,311.873"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M215.209,325.621c-3.805-7.681-3.558-16.644-0.271-24.56c2.314,3.526,2.596,8.015,2.173,12.211 c-0.423,4.196-1.7,8.514-1.783,12.73"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M200.008,317.955c-9.5-0.182-19.003,3.867-25.454,10.843c4.742,0.745,9.625-0.478,13.938-2.584 c4.313-2.106,8.145-5.061,11.944-7.994"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M189.789,314.537c-4.648-0.377-9.119-0.952-13.588,0.417c-4.468,1.369-8.535,4.478-10.357,8.781 c4.347,0.49,8.755-0.6,12.739-2.406C182.567,319.525,186.19,317.024,189.789,314.537"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M204.92,314.693c-4.181-2.74-8.474-5.529-13.342-6.664c-4.868-1.135-10.51-0.296-13.904,3.373 c3.941,2.313,8.722,2.586,13.291,2.582c4.569-0.004,10.17-0.055,14.478,1.469"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M204.945,314.914c-7.148-7.019-9.857-19.627-6.982-29.223 C203.582,294.228,206.098,304.76,204.945,314.914"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M224.599,295.028c1.348-3.134,2.296-6.423,3.506-9.613c1.209-3.19,2.713-6.329,4.998-8.862 c2.285-2.533,5.445-4.419,8.852-4.588c-2.133,9.658-8.548,18.287-17.181,23.113"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M221.043,299.171c-2.231-3.07-4.808-7.238-7.833-9.53c-3.025-2.292-6.964-3.679-10.656-2.799 C206.308,293.555,213.403,298.286,221.043,299.171"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M221.754,295.283c-1.462-3.716-2.935-7.47-3.526-11.419c-0.591-3.949-0.232-8.167,1.788-11.611 c3.924,7.417,5.187,15.378,1.939,23.114"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M224.635,272.253c2.222-7.353,8.955-12.766,16.223-15.25c0.916-0.313,1.887-0.574,2.844-0.426 c0.957,0.148,1.896,0.803,2.097,1.75c0.265,1.251-0.768,2.371-1.74,3.202C238.399,266.368,231.746,270.041,224.635,272.253"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M224.716,266.24c0.283-4.741,0.578-9.55,2.12-14.041c1.542-4.492,4.514-8.705,8.837-10.671 c0.735,4.788-1.377,9.551-3.925,13.671c-2.548,4.12-5.618,8.009-7.149,12.605"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M224.599,269.503c-1.837-5.358-2.027-12.164-5.235-16.833c-2.243-3.263-5.835-5.486-7.767-8.942 c-1.284,3.228-0.891,6.947,0.452,10.151c1.343,3.204,3.561,5.962,5.936,8.498C220.359,264.913,222.392,266.821,224.599,269.503 "
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M224.635,427.301c-0.143,0-0.266-35.745-0.276-79.829c-0.01-44.099,0.098-79.836,0.24-79.836 c0.143,0,0.266,35.737,0.276,79.836C224.886,391.556,224.778,427.301,224.635,427.301z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M255.872,320.228c0.01,0.034-0.469,0.212-1.344,0.505c-0.966,0.326-2.208,0.745-3.699,1.248 c-3.119,1.063-7.403,2.601-12.052,4.506c-4.604,1.975-8.946,3.578-11.418,5.721c-1.235,1.057-1.944,2.201-2.294,3.036 c-0.355,0.839-0.418,1.353-0.465,1.344c-0.018-0.003-0.012-0.131,0.015-0.375c0.041-0.241,0.103-0.601,0.262-1.042 c0.301-0.882,0.991-2.105,2.239-3.236c1.243-1.133,2.972-2.151,4.954-3.078c1.982-0.925,4.178-1.89,6.511-2.848 c4.664-1.911,8.981-3.4,12.135-4.376c1.576-0.492,2.862-0.854,3.754-1.093C255.364,320.306,255.862,320.193,255.872,320.228z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M266.111,295.078c0.012,0.013-0.118,0.151-0.377,0.402c-0.305,0.286-0.684,0.642-1.147,1.077 c-1.065,0.968-2.515,2.285-4.282,3.89c-3.697,3.292-8.712,7.757-14.252,12.69c-5.563,4.952-10.371,9.684-13.703,13.247 c-1.668,1.779-2.982,3.253-3.879,4.282c-0.419,0.478-0.761,0.869-1.036,1.183c-0.24,0.268-0.373,0.404-0.387,0.392 c-0.014-0.011,0.092-0.168,0.306-0.458c0.216-0.287,0.531-0.715,0.962-1.246c0.851-1.071,2.126-2.585,3.764-4.401 c3.272-3.635,8.053-8.423,13.628-13.384c5.583-4.941,10.663-9.379,14.354-12.578c1.812-1.555,3.298-2.83,4.391-3.767 c0.489-0.406,0.89-0.738,1.211-1.005C265.946,295.176,266.099,295.064,266.111,295.078z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M240.048,318.172c-0.146-0.065,1.016-2.748,2.174-6.142c1.169-3.393,1.719-6.257,1.867-6.233 c0.135,0.014-0.194,2.961-1.378,6.398c-0.582,1.716-1.225,3.225-1.73,4.296C240.474,317.563,240.111,318.201,240.048,318.172z "
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M224.668,339.808c-0.029,0.021-0.333-0.335-0.857-0.995c-0.582-0.746-1.318-1.69-2.196-2.816 c-1.845-2.385-4.395-5.676-7.254-9.278c-2.861-3.603-5.488-6.834-7.391-9.172c-0.897-1.111-1.65-2.042-2.244-2.778 c-0.524-0.661-0.801-1.038-0.774-1.061c0.027-0.023,0.356,0.309,0.927,0.93c0.572,0.62,1.383,1.533,2.371,2.674 c1.977,2.28,4.652,5.478,7.516,9.085c2.862,3.607,5.37,6.938,7.141,9.38c0.886,1.221,1.591,2.218,2.066,2.916 C224.448,339.391,224.697,339.787,224.668,339.808z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M217.819,331.015c-0.084,0.09-1.912-2.078-2.869-5.372c-0.706-2.321-0.738-4.445-0.651-5.416 l0.228,0.018c-0.102,0.414-0.177,0.632-0.218,0.626c-0.041-0.007-0.043-0.237-0.009-0.662l0.228,0.019 c0.083,0.963,0.23,3.013,0.916,5.268C216.369,328.688,217.957,330.927,217.819,331.015z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M208.977,319.892c-0.066,0.072-0.654-0.669-2.003-1.164c-1.338-0.518-3.352-0.632-5.562-0.442 c-2.212,0.162-4.188,0.557-5.601,0.904c-1.414,0.35-2.278,0.626-2.305,0.553c-0.023-0.061,0.799-0.459,2.207-0.905 c1.405-0.442,3.408-0.902,5.66-1.067c2.235-0.193,4.354-0.021,5.738,0.619C208.512,319.011,209.023,319.88,208.977,319.892z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M206.88,317.197c-0.039,0.08-1.167-0.468-3.069-1.118c-1.899-0.653-4.604-1.338-7.658-1.576 c-3.056-0.228-5.834,0.039-7.809,0.397c-1.979,0.354-3.176,0.725-3.203,0.64c-0.011-0.034,0.278-0.155,0.814-0.347 c0.533-0.199,1.325-0.426,2.318-0.651c1.982-0.455,4.809-0.786,7.92-0.554c3.109,0.242,5.853,0.998,7.743,1.748 c0.947,0.373,1.696,0.717,2.193,0.995C206.629,317.001,206.897,317.165,206.88,317.197z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M224.599,305.797c-0.138,0.035-1.14-3.446-2.238-7.775c-1.098-4.33-1.876-7.868-1.738-7.903 c0.138-0.035,1.14,3.446,2.238,7.776C223.96,302.224,224.738,305.762,224.599,305.797z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M224.742,305.797c-0.154,0.05-0.798-2.276-2.481-4.655c-1.638-2.429-3.728-3.648-3.651-3.768 c0.027-0.054,0.604,0.158,1.409,0.727c0.807,0.562,1.805,1.514,2.665,2.745C224.43,303.321,224.867,305.789,224.742,305.797z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M224.635,408.246c-0.056,0.008-0.161-0.859-0.564-2.377c-0.398-1.518-1.148-3.671-2.389-6.189 c-2.47-5.047-6.963-11.445-12.674-17.855c-2.829-3.233-5.575-6.282-7.904-9.202c-2.334-2.916-4.252-5.694-5.652-8.152 c-1.405-2.456-2.32-4.563-2.853-6.05c-0.262-0.746-0.455-1.327-0.56-1.73c-0.113-0.4-0.164-0.612-0.147-0.617 c0.046-0.015,0.306,0.818,0.895,2.275c0.588,1.456,1.547,3.524,2.981,5.938c1.43,2.416,3.365,5.153,5.708,8.038 c2.339,2.89,5.089,5.923,7.923,9.161c5.725,6.426,10.208,12.906,12.613,18.036c1.209,2.56,1.914,4.754,2.255,6.299 c0.166,0.774,0.277,1.377,0.316,1.793C224.635,408.026,224.653,408.244,224.635,408.246z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M252.862,376.364c0.017,0.038-0.523,0.311-1.479,0.831c-0.949,0.533-2.295,1.354-3.837,2.536 c-1.542,1.181-3.268,2.732-5.039,4.596c-1.769,1.868-3.591,4.038-5.45,6.363c-3.718,4.665-7.195,8.793-9.277,12.087 c-1.057,1.634-1.826,3.012-2.329,3.979c-0.508,0.964-0.777,1.506-0.814,1.489c-0.016-0.007,0.031-0.151,0.137-0.42 c0.11-0.266,0.26-0.665,0.497-1.159c0.45-0.998,1.175-2.413,2.201-4.085c2.022-3.374,5.472-7.559,9.183-12.216 c1.863-2.329,3.707-4.504,5.509-6.37c1.805-1.862,3.576-3.403,5.164-4.559c1.588-1.158,2.978-1.94,3.963-2.422 c0.49-0.246,0.89-0.397,1.155-0.511C252.711,376.396,252.855,376.348,252.862,376.364z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M253.415,386.707c0.006,0.075-1.194,0.221-3.127,0.454c-1.926,0.249-4.607,0.571-7.416,1.461 c-2.798,0.911-5.124,2.3-6.64,3.484c-1.531,1.183-2.252,2.161-2.323,2.104c-0.025-0.018,0.125-0.285,0.463-0.72 c0.334-0.438,0.882-1.023,1.629-1.667c1.491-1.285,3.84-2.757,6.712-3.693c2.877-0.91,5.595-1.175,7.538-1.332 C252.201,386.656,253.409,386.64,253.415,386.707z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M234.822,393.074c-0.163-0.092,1.246-2.245,2.339-5.14c1.026-2.922,1.266-5.483,1.45-5.454 c0.067,0.008,0.064,0.649-0.052,1.678c-0.123,1.025-0.369,2.451-0.912,3.952c-0.546,1.499-1.263,2.752-1.814,3.625 C235.275,392.606,234.879,393.11,234.822,393.074z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M262.004,348.596c0.006,0.017-0.166,0.108-0.5,0.266c-0.388,0.176-0.874,0.397-1.469,0.668 c-0.644,0.276-1.425,0.626-2.305,1.09c-0.883,0.456-1.914,0.925-2.988,1.57c-0.545,0.31-1.114,0.633-1.706,0.97 c-0.591,0.34-1.176,0.744-1.799,1.134c-1.258,0.763-2.517,1.702-3.862,2.661c-2.631,1.997-5.398,4.36-8.061,7.09 c-2.638,2.756-4.906,5.603-6.812,8.301c-0.913,1.377-1.809,2.668-2.528,3.951c-0.368,0.636-0.752,1.234-1.072,1.837 c-0.316,0.603-0.62,1.183-0.911,1.738c-0.607,1.095-1.041,2.141-1.467,3.039c-0.434,0.895-0.757,1.688-1.011,2.341 c-0.25,0.604-0.454,1.098-0.617,1.491c-0.147,0.339-0.232,0.515-0.249,0.509c-0.017-0.006,0.035-0.193,0.151-0.544 c0.139-0.404,0.314-0.909,0.528-1.529c0.226-0.666,0.523-1.473,0.933-2.384c0.402-0.914,0.815-1.976,1.405-3.088 c0.283-0.564,0.579-1.152,0.887-1.764c0.312-0.611,0.69-1.219,1.053-1.864c0.708-1.301,1.597-2.61,2.506-4.004 c1.898-2.733,4.174-5.612,6.833-8.39c2.684-2.751,5.483-5.123,8.149-7.113c1.362-0.956,2.64-1.888,3.916-2.641 c0.632-0.385,1.226-0.782,1.826-1.116c0.601-0.328,1.179-0.644,1.733-0.947c1.091-0.628,2.139-1.077,3.038-1.51 c0.896-0.441,1.693-0.766,2.351-1.014c0.612-0.235,1.111-0.427,1.51-0.58C261.812,348.638,261.997,348.58,262.004,348.596z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M239.664,363.564c-0.046-0.007,0.203-0.875,1.228-1.829c1-0.953,2.825-1.835,4.949-1.899 c2.118-0.056,3.954,0.536,5.208,1.017c1.261,0.495,1.994,0.897,1.969,0.957c-0.029,0.072-0.815-0.211-2.089-0.612 c-1.27-0.389-3.065-0.901-5.072-0.846c-2,0.061-3.726,0.832-4.728,1.659C240.107,362.836,239.747,363.614,239.664,363.564z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M236.325,367.009c-0.142-0.079,1.118-1.926,1.405-4.572c0.33-2.642-0.471-4.729-0.315-4.773 c0.057-0.023,0.338,0.462,0.581,1.332c0.244,0.865,0.406,2.125,0.247,3.501c-0.163,1.375-0.61,2.564-1.047,3.35 C236.76,366.637,236.375,367.045,236.325,367.009z"
    }
  })])])])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M199.947,413.368c0.77,13.66,4.887,27.553,11.218,41.599h27.534 c6.038-13.906,9.87-27.778,10.552-41.599H199.947z"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#fafafa"
    },
    attrs: {
      "d": "M244.789,435.473c0,0.143-9.066,0.258-20.246,0.258c-11.184,0-20.248-0.116-20.248-0.258 c0-0.143,9.064-0.258,20.248-0.258C235.723,435.214,244.789,435.33,244.789,435.473z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#fafafa"
    },
    attrs: {
      "d": "M244.173,440.421c0,0.143-8.499,0.259-18.98,0.259c-10.485,0-18.982-0.116-18.982-0.259 c0-0.142,8.497-0.258,18.982-0.258C235.675,440.163,244.173,440.279,244.173,440.421z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#fafafa"
    },
    attrs: {
      "d": "M211.61,422.337c0.143,0,0.258,2.84,0.258,6.342c0,3.503-0.116,6.342-0.258,6.342 c-0.143,0-0.258-2.839-0.258-6.342C211.352,425.177,211.467,422.337,211.61,422.337z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#fafafa"
    },
    attrs: {
      "d": "M226.362,422.337c0.143,0,0.258,2.941,0.258,6.568c0,3.628-0.115,6.568-0.258,6.568 c-0.143,0-0.258-2.94-0.258-6.568C226.104,425.278,226.22,422.337,226.362,422.337z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#fafafa"
    },
    attrs: {
      "d": "M240.212,422.226c0.143,0,0.258,2.999,0.258,6.699c0,3.7-0.116,6.699-0.258,6.699 c-0.143,0-0.258-2.999-0.258-6.699C239.953,425.225,240.069,422.226,240.212,422.226z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#fafafa"
    },
    attrs: {
      "d": "M248.377,422.337c0,0.143-10.633,0.258-23.746,0.258c-13.118,0-23.748-0.116-23.748-0.258 c0-0.143,10.631-0.258,23.748-0.258C237.744,422.079,248.377,422.194,248.377,422.337z"
    }
  })])])])]), _c('g', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "transform": "matrix(0.7148120403289795, 0, 0, 0.7148120403289795, -17.128992080688477, -16.451345443725586)"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#f5f5f5"
    },
    attrs: {
      "d": "M548.979,124.983l-2.31-3.806c-19.47-32.084-54.671-51.425-91.785-49.078 c-4.771,0.302-9.521,0.948-14.208,1.951c-33.744,7.223-63.105,32.741-75.276,65.422c-7.158,19.22-9.157,41.35-22.74,56.605 c-17.677,19.855-47.689,20.478-74.075,19.656c-26.386-0.823-56.417-0.121-74.009,19.812 c-11.017,12.484-14.518,30.237-13.63,46.955c2.352,44.263,33.195,83.84,72.419,103.512c39.225,19.672,85.407,21.434,128.336,12.78 c60.138-12.123,117.329-45.415,151.705-96.835C567.784,250.537,576.484,180.482,548.979,124.983z"
    }
  })]), _c('g', {
    attrs: {
      "transform": "matrix(0.7148120403289795, 0, 0, 0.7148120403289795, -17.128992080688477, -16.451345443725586)"
    }
  }, [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M713.401,455.228c0,0.144-151.52,0.261-338.385,0.261c-186.931,0-338.418-0.117-338.418-0.261 c0-0.144,151.487-0.261,338.418-0.261C561.882,454.967,713.401,455.084,713.401,455.228z"
    }
  })])]), _c('g', {
    attrs: {
      "transform": "matrix(0.7148120403289795, 0, 0, 0.7148120403289795, -17.128992080688477, -16.451345443725586)"
    }
  }, [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M495.931,272.411c9.526,4.934,16.83,13.43,22.083,22.784c5.252,9.354,8.637,19.619,11.99,29.809 l2.934,52.556c-11.084-18.856-19.98-41.023-22.384-62.763c2.459-0.219,4.917-0.438,7.376-0.657 c-4.945-0.755-9.097-4.338-11.738-8.587c-2.641-4.249-4.001-9.148-5.328-13.972c3,0.446,5.999,0.892,8.999,1.338 C502.817,288.216,497.708,280.696,495.931,272.411z"
    }
  })]), _c('g', {
    staticStyle: {
      "opacity": "0.3"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M495.931,272.411c9.526,4.934,16.83,13.43,22.083,22.784c5.252,9.354,8.637,19.619,11.99,29.809l2.934,52.556 c-11.084-18.856-19.98-41.023-22.384-62.763c2.459-0.219,4.917-0.438,7.376-0.657c-4.945-0.755-9.097-4.338-11.738-8.587 c-2.641-4.249-4.001-9.148-5.328-13.972c3,0.446,5.999,0.892,8.999,1.338C502.817,288.216,497.708,280.696,495.931,272.411z"
    }
  })])]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M534.579,389.875c0,0,24.058-28.796,23.78-56.284h-9.718c0,0,10.556-6.942,9.721-10.829 c-0.835-3.887-1.113-18.604-1.113-18.604l-8.885,2.221c0,0,6.664-3.332,7.497-8.608c0.833-5.276-1.944-29.71-1.944-29.71 s-10.829,11.384-14.161,23.046c-3.332,11.662-12.078,25.268-9.51,60.809C532.814,387.458,534.579,389.875,534.579,389.875z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M522.383,392.593c0,0-26.065-17.363-31.855-39.525l7.813-2.126c0,0-10.005-3.271-10.184-6.579 c-0.179-3.308-3.175-15.2-3.175-15.2l7.63-0.158c0,0-6.087-1.221-7.911-5.28c-1.824-4.059-4.938-24.312-4.938-24.312 s11.197,6.783,16.427,15.43c5.23,8.647,15.239,17.672,20.95,46.808C522.85,390.788,522.383,392.593,522.383,392.593z"
    }
  })]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M547.345,293.167c0.009,0.002-0.004,0.107-0.038,0.309c-0.042,0.23-0.095,0.526-0.162,0.896 c-0.161,0.82-0.387,1.971-0.674,3.435c-0.305,1.489-0.666,3.313-1.061,5.435c-0.402,2.121-0.878,4.533-1.344,7.21 c-0.986,5.344-2.038,11.729-3.132,18.829c-1.06,7.105-2.129,14.931-3.091,23.166c-0.943,8.239-1.687,16.105-2.277,23.266 c-0.555,7.163-0.988,13.62-1.247,19.048c-0.157,2.713-0.245,5.169-0.337,7.326c-0.099,2.156-0.164,4.015-0.207,5.534 c-0.054,1.491-0.097,2.663-0.128,3.498c-0.019,0.376-0.034,0.676-0.046,0.91c-0.013,0.205-0.025,0.31-0.034,0.31 c-0.009,0-0.016-0.105-0.02-0.311c-0.001-0.234-0.003-0.534-0.005-0.91c0.007-0.836,0.017-2.008,0.03-3.501 c0.012-1.52,0.047-3.38,0.119-5.539c0.065-2.159,0.126-4.617,0.26-7.333c0.212-5.434,0.607-11.897,1.136-19.068 c0.564-7.168,1.295-15.042,2.238-23.288c0.963-8.241,2.047-16.072,3.134-23.178c1.121-7.102,2.211-13.485,3.244-18.823 c0.49-2.674,0.99-5.082,1.42-7.199c0.423-2.118,0.812-3.937,1.148-5.42c0.328-1.456,0.586-2.6,0.77-3.416 c0.088-0.366,0.158-0.658,0.213-0.885C547.306,293.266,547.336,293.165,547.345,293.167z"
    }
  })])]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M537.916,407.508c0,0,22.016-24.98,28.852-40.081l-5.161-2.205 c3.741,0.617,7.573-0.99,10.474-3.432c2.901-2.441,5.031-5.653,7.119-8.817l-6.798-1.149c6.182-1.735,11.629-5.954,14.854-11.506 c-8.022,1.319-15.28,5.726-21.261,11.233c-4.843,4.46-8.945,9.638-12.883,14.927c-1.921,2.581-3.603,5.33-5.003,8.226 C544.409,382.354,537.904,398.335,537.916,407.508z"
    }
  })]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M490.181,313.952c0.008-0.004,0.057,0.074,0.146,0.232c0.1,0.185,0.226,0.417,0.382,0.704 c0.343,0.659,0.819,1.573,1.422,2.731c1.233,2.373,2.953,5.84,5.017,10.154c4.134,8.624,9.524,20.698,14.794,34.309 c5.26,13.621,9.395,26.182,12.138,35.343c1.374,4.58,2.434,8.302,3.119,10.887c0.333,1.263,0.596,2.258,0.785,2.977 c0.078,0.317,0.141,0.573,0.192,0.778c0.04,0.176,0.057,0.267,0.048,0.27c-0.009,0.002-0.042-0.084-0.099-0.256 c-0.063-0.201-0.143-0.452-0.241-0.764c-0.212-0.712-0.506-1.698-0.879-2.95c-0.744-2.567-1.857-6.271-3.275-10.834 c-2.831-9.128-7.017-21.656-12.271-35.263c-5.264-13.598-10.595-25.682-14.641-34.34c-2.02-4.33-3.689-7.82-4.865-10.22 c-0.566-1.177-1.012-2.105-1.334-2.774c-0.137-0.297-0.247-0.536-0.335-0.728C490.206,314.043,490.173,313.957,490.181,313.952z "
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M536.049,418.213c-0.018-0.002-0.014-0.164,0.008-0.471c0.034-0.367,0.075-0.809,0.125-1.339 c0.11-1.163,0.346-2.839,0.707-4.897c0.716-4.116,2.086-9.754,4.336-15.732c2.263-5.976,4.961-11.112,7.144-14.674 c1.089-1.784,2.02-3.197,2.706-4.142c0.314-0.431,0.574-0.79,0.791-1.088c0.186-0.245,0.29-0.369,0.305-0.359 c0.015,0.01-0.061,0.154-0.218,0.418c-0.194,0.313-0.428,0.689-0.709,1.141c-0.633,0.978-1.513,2.417-2.557,4.218 c-2.094,3.597-4.723,8.729-6.974,14.671c-2.237,5.944-3.655,11.533-4.461,15.616c-0.406,2.041-0.697,3.703-0.868,4.856 c-0.088,0.525-0.161,0.962-0.222,1.325C536.105,418.057,536.066,418.215,536.049,418.213z"
    }
  })])]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ff725e"
    },
    attrs: {
      "x": "506.998",
      "y": "412.337",
      "width": "48.185",
      "height": "9.829"
    }
  })]), _c('g', [_c('polygon', {
    staticStyle: {
      "fill": "#ff725e"
    },
    attrs: {
      "points": "550.592,422.166 545.38,455.227 516.263,455.227 511.405,422.166 &#9;&#9;&#9;"
    }
  })]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M509.954,422.166c0-0.144,9.115-0.26,20.357-0.26c11.246,0,20.359,0.117,20.359,0.26 s-9.113,0.26-20.359,0.26C519.069,422.427,509.954,422.31,509.954,422.166z"
    }
  })])])]), _c('g', {
    attrs: {
      "transform": "matrix(0.7148120403289795, 0, 0, 0.7148120403289795, -17.128992080688477, -16.451345443725586)"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M497.601,455.01l-250.191,0c-6.771,0-12.26-5.489-12.26-12.26l0-369.716 c0-6.771,5.489-12.26,12.26-12.26l250.191,0c6.771,0,12.261,5.489,12.261,12.261l0,369.714 C509.862,449.521,504.373,455.01,497.601,455.01z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M497.601,455.01c0,0,0.287-0.024,0.855-0.057 c0.285-0.004,0.635-0.056,1.053-0.127c0.422-0.048,0.899-0.171,1.44-0.319 c1.07-0.319,2.386-0.841,3.736-1.813c1.336-0.969,2.735-2.373,3.741-4.317 c0.512-0.966,0.883-2.07,1.141-3.261c0.239-1.2,0.234-2.488,0.227-3.842 c-0.004-2.707-0.008-5.667-0.013-8.873c-0.007-6.413-0.016-13.812-0.025-22.141 c-0.021-33.323-0.051-81.534-0.088-141.106c-0.01-29.788-0.022-62.415-0.034-97.441 c-0.005-17.513-0.009-35.626-0.014-54.284c-0.002-9.329-0.004-18.794-0.006-28.388 c-0.001-4.797-0.002-9.626-0.003-14.487c-0.015-1.222,0.047-2.425-0.193-3.596 c-0.222-1.169-0.561-2.332-1.133-3.387c-1.085-2.14-2.845-3.92-4.953-5.089 c-1.068-0.562-2.211-0.971-3.394-1.221c-1.191-0.234-2.397-0.236-3.645-0.23 c-2.477,0-4.961,0.001-7.452,0.001c-4.983,0.001-9.996,0.002-15.038,0.002 c-10.084,0.001-20.283,0.003-30.59,0.004c-20.615,0.002-41.664,0.005-63.093,0.007 c-42.857,0.002-87.229,0.004-132.676,0.006c-2.782,0.009-5.538,0.986-7.676,2.756 c-2.134,1.772-3.611,4.292-4.126,7.004c-0.288,1.35-0.194,2.751-0.215,4.168v4.226c0,2.815,0,5.626,0,8.432 c0,11.224-0.001,22.374-0.001,33.443c-0.001,22.138-0.003,43.951-0.004,65.384 c-0.005,42.867-0.011,84.215-0.016,123.604c-0.009,39.389-0.018,76.818-0.026,111.847 c-0.001,4.379-0.003,8.72-0.004,13.022c-0.001,2.151-0.001,4.293-0.002,6.425 c0.004,1.071-0.026,2.124,0.143,3.151c0.123,1.037,0.456,2.032,0.836,2.994 c1.639,3.819,5.32,6.648,9.379,7.154c1.004,0.153,2.028,0.13,3.065,0.132c1.031,0,2.06,0.001,3.087,0.001 c2.053,0.001,4.095,0.001,6.128,0.002c16.259,0.006,31.863,0.012,46.757,0.018 c59.572,0.037,107.779,0.067,141.098,0.088c16.655,0.023,29.587,0.04,38.362,0.052 c4.382,0.012,7.724,0.021,9.976,0.027C496.45,454.991,497.601,455.01,497.601,455.01 s-1.152,0.019-3.399,0.028c-2.252,0.006-5.594,0.015-9.976,0.027c-8.774,0.012-21.707,0.029-38.362,0.052 c-33.319,0.021-81.526,0.051-141.098,0.088c-14.893,0.006-30.497,0.012-46.757,0.018 c-2.032,0.001-4.075,0.001-6.128,0.002c-1.026,0-2.055,0.001-3.087,0.001 c-1.023-0.001-2.078,0.023-3.125-0.134c-4.207-0.523-8.025-3.45-9.726-7.41 c-0.396-0.997-0.74-2.029-0.869-3.104c-0.176-1.07-0.145-2.158-0.149-3.215 c-0.001-2.132-0.001-4.274-0.002-6.425c-0.001-4.303-0.002-8.644-0.004-13.022 c-0.008-35.029-0.017-72.459-0.025-111.847c-0.005-39.389-0.011-80.737-0.016-123.604 c-0.001-21.433-0.003-43.246-0.004-65.384c0-11.069-0.001-22.219-0.001-33.443c0-2.806,0-5.617,0-8.432 l0-4.226c0.021-1.394-0.077-2.843,0.224-4.27c0.538-2.839,2.084-5.475,4.316-7.328 c2.235-1.851,5.123-2.875,8.029-2.883c45.447,0.002,89.819,0.004,132.676,0.006 c21.428,0.002,42.478,0.005,63.093,0.007c10.307,0.001,20.506,0.003,30.59,0.004 c5.042,0.001,10.055,0.001,15.038,0.002c2.492,0,4.976,0.001,7.452,0.001 c1.226-0.005,2.505-0.004,3.744,0.241c1.234,0.26,2.427,0.688,3.539,1.275 c2.198,1.219,4.031,3.074,5.161,5.305c0.594,1.101,0.95,2.313,1.18,3.531 c0.249,1.227,0.184,2.481,0.199,3.683c-0.001,4.861-0.002,9.69-0.003,14.487 c-0.002,9.594-0.004,19.059-0.006,28.388c-0.005,18.657-0.009,36.771-0.014,54.284 c-0.012,35.026-0.023,67.654-0.034,97.441c-0.037,59.572-0.067,107.783-0.088,141.106 c-0.01,8.329-0.018,15.728-0.025,22.141c-0.005,3.206-0.009,6.166-0.013,8.873 c0.002,1.349,0.004,2.655-0.243,3.866c-0.265,1.202-0.644,2.315-1.164,3.288 c-1.024,1.957-2.44,3.365-3.791,4.334c-1.365,0.971-2.692,1.487-3.769,1.799 c-0.545,0.144-1.025,0.263-1.449,0.307c-0.42,0.067-0.772,0.115-1.057,0.114 C497.889,455.005,497.601,455.01,497.601,455.01z"
    }
  })])])])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M400.652,81.607h-56.104c-2.161,0-3.913-1.752-3.913-3.913l0,0 c0-2.161,1.752-3.913,3.913-3.913h56.104c2.161,0,3.913,1.752,3.913,3.913l0,0 C404.565,79.856,402.813,81.607,400.652,81.607z"
    }
  })])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "x": "243.575",
      "y": "88.9",
      "width": "257.387",
      "height": "329.235"
    }
  })])])])])])])])])])])])]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#fafafa"
    },
    attrs: {
      "x": "247.874",
      "y": "97.892",
      "width": "247.908",
      "height": "312.646"
    }
  })]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "247.874",
      "y": "97.892",
      "width": "247.908",
      "height": "19.133"
    }
  })]), _c('g', [_c('circle', {
    staticStyle: {
      "fill": "#fafafa"
    },
    attrs: {
      "cx": "258.423",
      "cy": "106.491",
      "r": "3.378"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#fafafa"
    },
    attrs: {
      "d": "M271.335,106.491c0,1.865-1.512,3.378-3.378,3.378c-1.865,0-3.378-1.512-3.378-3.378 c0-1.865,1.512-3.377,3.378-3.377C269.823,103.114,271.335,104.626,271.335,106.491z"
    }
  })]), _c('g', [_c('circle', {
    staticStyle: {
      "fill": "#fafafa"
    },
    attrs: {
      "cx": "277.493",
      "cy": "106.491",
      "r": "3.378"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M411.689,166.607h-78.179c-10.511,0-19.032-8.521-19.032-19.032v-2.055 c0-10.511,8.521-19.032,19.032-19.032h78.179c10.511,0,19.032,8.521,19.032,19.032v2.055 C430.721,158.086,422.201,166.607,411.689,166.607z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M321.539,187.77h-45.678c-2.499,0-4.526-2.026-4.526-4.526v-0.489 c0-2.499,2.026-4.526,4.526-4.526h45.678c2.5,0,4.526,2.026,4.526,4.526v0.489C326.065,185.744,324.038,187.77,321.539,187.77z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M443.265,288.512h-45.678c-2.499,0-4.526-2.026-4.526-4.526v-0.489 c0-2.499,2.026-4.526,4.526-4.526h45.678c2.5,0,4.526,2.026,4.526,4.526v0.489C447.791,286.486,445.764,288.512,443.265,288.512z "
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M394.193,187.77h-45.678c-2.5,0-4.526-2.026-4.526-4.526v-0.489c0-2.499,2.026-4.526,4.526-4.526 h45.678c2.499,0,4.526,2.026,4.526,4.526v0.489C398.718,185.744,396.692,187.77,394.193,187.77z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M463.322,187.77h-45.678c-2.499,0-4.526-2.026-4.526-4.526v-0.489 c0-2.499,2.026-4.526,4.526-4.526h45.678c2.5,0,4.526,2.026,4.526,4.526v0.489C467.848,185.744,465.821,187.77,463.322,187.77z"
    }
  })]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "x": "247.874",
      "y": "196.862",
      "width": "247.908",
      "height": "60.053"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M303.474,228.027h-37.94c-2.499,0-4.526-2.026-4.526-4.526v-0.489 c0-2.499,2.026-4.526,4.526-4.526h37.94c2.5,0,4.526,2.026,4.526,4.526v0.489C307.999,226,305.973,228.027,303.474,228.027z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M333.737,238.5h-70.368c-1.304,0-2.361-1.057-2.361-2.361v-0.255c0-1.304,1.057-2.361,2.361-2.361 h70.368c1.304,0,2.361,1.057,2.361,2.361v0.255C336.099,237.443,335.042,238.5,333.737,238.5z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M466.02,302.079h-70.368c-1.304,0-2.361-1.057-2.361-2.361v-0.255 c0-1.304,1.057-2.361,2.361-2.361h70.368c1.304,0,2.361,1.057,2.361,2.361v0.255C468.382,301.021,467.324,302.079,466.02,302.079 z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M430.82,314.465h-35.397c-1.304,0-2.361-1.057-2.361-2.361v-0.255 c0-1.304,1.057-2.361,2.361-2.361h35.397c1.304,0,2.361,1.057,2.361,2.361v0.255C433.181,313.408,432.124,314.465,430.82,314.465 z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M330.721,357.955h-45.678c-2.499,0-4.526-2.026-4.526-4.526v-0.489 c0-2.499,2.026-4.526,4.526-4.526h45.678c2.5,0,4.526,2.026,4.526,4.526v0.489C335.247,355.929,333.221,357.955,330.721,357.955z "
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M353.477,371.521h-70.368c-1.304,0-2.361-1.057-2.361-2.361v-0.255 c0-1.304,1.057-2.361,2.361-2.361h70.368c1.304,0,2.361,1.057,2.361,2.361v0.255 C355.838,370.464,354.781,371.521,353.477,371.521z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M318.276,383.908h-35.397c-1.304,0-2.361-1.057-2.361-2.361v-0.255 c0-1.304,1.057-2.361,2.361-2.361h35.397c1.304,0,2.361,1.057,2.361,2.361v0.255C320.637,382.85,319.58,383.908,318.276,383.908z "
    }
  })]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ebebeb"
    },
    attrs: {
      "x": "358.758",
      "y": "196.564",
      "width": "137.024",
      "height": "60.053"
    }
  })]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ebebeb"
    },
    attrs: {
      "x": "270.454",
      "y": "271.119",
      "width": "100.9",
      "height": "51.2"
    }
  })]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ebebeb"
    },
    attrs: {
      "x": "384.427",
      "y": "342.562",
      "width": "92.818",
      "height": "51.2"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff725e"
    },
    attrs: {
      "d": "M443.921,272.769H312.253c-13.214,0-23.926-10.712-23.926-23.926v-2.583 c0-13.214,10.712-23.926,23.926-23.926h131.668c13.214,0,23.926,10.712,23.926,23.926v2.583 C467.848,262.057,457.135,272.769,443.921,272.769z"
    }
  })]), _c('g', {
    attrs: {
      "transform": "matrix(1, 0, 0, 1, -17.914551, -0.827711)"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M 366.259 253.265 L 367.302 250.922 C 368.297 251.58 369.71 252.029 371.01 252.029 C 372.326 252.029 372.84 251.659 372.84 251.114 C 372.84 249.333 366.452 250.633 366.452 246.459 C 366.452 244.453 368.089 242.816 371.428 242.816 C 372.889 242.816 374.397 243.153 375.505 243.795 L 374.526 246.154 C 373.451 245.577 372.391 245.288 371.412 245.288 C 370.08 245.288 369.598 245.738 369.598 246.299 C 369.598 248.017 375.97 246.733 375.97 250.873 C 375.97 252.831 374.333 254.501 370.994 254.501 C 369.148 254.501 367.318 254.003 366.259 253.265 Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M 379.662 245.561 L 376.211 245.561 L 376.211 243.041 L 386.275 243.041 L 386.275 245.561 L 382.84 245.561 L 382.84 254.276 L 379.662 254.276 L 379.662 245.561 Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M 414.097 245.561 L 410.646 245.561 L 410.646 243.041 L 420.71 243.041 L 420.71 245.561 L 417.275 245.561 L 417.275 254.276 L 414.097 254.276 L 414.097 245.561 Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M 394.429 252.093 L 389.678 252.093 L 388.795 254.276 L 385.553 254.276 L 390.513 243.042 L 393.643 243.042 L 398.618 254.276 L 395.312 254.276 L 394.429 252.093 Z M 393.499 249.75 L 392.054 246.154 L 390.61 249.75 L 393.499 249.75 Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M 404.43 251.29 L 402.696 251.29 L 402.696 254.276 L 399.518 254.276 L 399.518 243.042 L 404.654 243.042 C 407.72 243.042 409.645 244.631 409.645 247.199 C 409.645 248.852 408.843 250.072 407.447 250.746 L 409.87 254.276 L 406.468 254.276 L 404.43 251.29 Z M 404.463 245.545 L 402.697 245.545 L 402.697 248.835 L 404.463 248.835 C 405.778 248.835 406.437 248.226 406.437 247.198 C 406.437 246.154 405.778 245.545 404.463 245.545 Z"
    }
  })]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M495.782,410.537c-0.002-2.045-0.095-126.926-0.233-312.645l0.233,0.233 c-73.854,0.008-158.422,0.017-247.881,0.027h-0.027l0.26-0.26c-0.016,115.792-0.032,223.372-0.044,312.645l-0.216-0.216 C397.391,410.452,493.982,410.536,495.782,410.537c-1.799,0.002-98.391,0.086-247.908,0.216l-0.216,0l0-0.216 c-0.013-89.273-0.028-196.853-0.044-312.645v-0.26h0.26h0.027c89.459,0.01,174.027,0.019,247.881,0.027h0.234l0,0.233 C495.877,283.611,495.783,408.494,495.782,410.537z"
    }
  })])])]), _c('g', {
    attrs: {
      "transform": "matrix(0.7148120403289795, 0, 0, 0.7148120403289795, -17.128992080688477, -16.451345443725586)"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M579.137,115.687l-2.754-8.154c2.485-4.215,3.873-9.148,3.77-14.399 c-0.294-15.102-12.775-27.106-27.877-26.812c-15.102,0.294-27.106,12.775-26.812,27.877 c0.294,15.102,12.775,27.106,27.878,26.812c6.306-0.123,12.067-2.376,16.623-6.052l-0.009,0.013L579.137,115.687z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M579.137,115.687c0,0-0.183-0.003-0.569-0.025c-0.415-0.026-0.992-0.062-1.739-0.109 c-1.586-0.107-3.891-0.261-6.883-0.463c-0.065-0.004-0.115-0.061-0.11-0.126c0.001-0.023,0.011-0.046,0.023-0.063 c0,0,0.006-0.008,0.009-0.012l0.172,0.163c-2.759,2.246-6.871,4.695-12.292,5.7c-2.693,0.525-5.689,0.605-8.807,0.171 c-3.115-0.429-6.361-1.427-9.439-3.121c-3.076-1.687-5.976-4.068-8.348-7.071c-2.373-2.996-4.21-6.62-5.18-10.603 c-1.99-7.93-0.149-17.386,5.74-24.253c2.944-3.471,6.662-6.195,10.74-7.789c4.059-1.636,8.394-2.252,12.525-1.941 c4.138,0.32,8.045,1.611,11.4,3.521c3.362,1.912,6.173,4.452,8.316,7.266c4.307,5.662,5.878,12.251,5.624,17.715 c-0.213,5.521-2.028,9.934-3.835,12.947l0.01-0.096c0.866,2.66,1.534,4.713,1.995,6.129 c0.213,0.665,0.378,1.179,0.497,1.552C579.093,115.521,579.137,115.687,579.137,115.687s-0.076-0.191-0.203-0.545 c-0.133-0.376-0.318-0.895-0.556-1.567c-0.486-1.387-1.191-3.399-2.104-6.005c-0.011-0.032-0.006-0.069,0.01-0.096 c1.752-3.011,3.503-7.392,3.674-12.841c0.213-5.396-1.372-11.871-5.629-17.422c-2.118-2.759-4.889-5.245-8.196-7.113 c-3.3-1.866-7.135-3.124-11.195-3.43c-4.055-0.297-8.304,0.314-12.281,1.921c-3.997,1.565-7.638,4.238-10.524,7.64 c-5.771,6.731-7.584,15.992-5.648,23.776c0.945,3.908,2.738,7.467,5.061,10.416c2.321,2.956,5.163,5.305,8.18,6.976 c3.02,1.678,6.208,2.674,9.273,3.113c3.068,0.443,6.023,0.383,8.684-0.117c5.356-0.953,9.443-3.335,12.207-5.527 c0.051-0.042,0.126-0.034,0.168,0.017c0.035,0.043,0.034,0.104,0.004,0.147c-0.003,0.004-0.009,0.012-0.009,0.012 l-0.087-0.189c2.949,0.262,5.222,0.464,6.787,0.603c0.76,0.071,1.346,0.125,1.769,0.165 C578.92,115.658,579.137,115.687,579.137,115.687z"
    }
  })])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M546.771,87.136h4.16c0,0,0-3.493,3.63-3.555c1.885-0.033,2.863,1.202,3.26,2.148 c0.461,1.099,0.322,2.351-0.296,3.369c-0.706,1.163-2.252,2.221-5.055,1.727l0,9.379h4.113l0-5.494 c0,0,5.769-1.491,5.769-7.849c0-6.083-5.455-7.496-7.79-7.496C552.776,79.366,546.693,79.798,546.771,87.136z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "x": "552.458",
      "y": "102.137",
      "width": "4.174",
      "height": "3.899"
    }
  })])])])])]), _c('g', {
    attrs: {
      "transform": "matrix(0.7148120403289795, 0, 0, 0.7148120403289795, -17.128992080688477, -16.451345443725586)"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M157.439,135.186l4.432-7.546c-1.6-4.711-1.959-9.909-0.768-15.116 c3.423-14.973,18.336-24.335,33.309-20.911c14.973,3.424,24.335,18.336,20.911,33.309 c-3.424,14.972-18.337,24.335-33.309,20.911c-6.252-1.429-11.52-4.867-15.293-9.471l0.007,0.014L157.439,135.186z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M157.439,135.186c0,0,0.22,0.017,0.626,0.063c0.425,0.048,1.02,0.117,1.793,0.205 c1.582,0.187,3.889,0.459,6.884,0.813l-0.115,0.156c0,0-0.004-0.009-0.006-0.014 c-0.026-0.056-0.001-0.122,0.054-0.147c0.046-0.021,0.101-0.007,0.133,0.031c2.297,2.757,5.872,5.978,11.008,8.04 c2.546,1.05,5.477,1.724,8.625,1.919c3.144,0.199,6.527-0.13,9.884-1.175c3.353-1.038,6.671-2.788,9.597-5.251 c2.926-2.456,5.451-5.63,7.204-9.327c3.545-7.353,3.661-16.957-0.693-24.861c-2.17-3.989-5.243-7.407-8.901-9.795 c-3.629-2.426-7.736-3.916-11.837-4.461c-4.108-0.537-8.191-0.079-11.865,1.096c-3.682,1.176-6.957,3.078-9.639,5.388 c-5.391,4.648-8.312,10.77-9.217,16.189c-0.958,5.464-0.12,10.19,1.002,13.551c0.01,0.03,0.005,0.064-0.009,0.089 c-1.45,2.411-2.568,4.27-3.336,5.548c-0.377,0.621-0.668,1.101-0.876,1.444 C157.553,135.013,157.439,135.186,157.439,135.186s0.079-0.156,0.261-0.477c0.195-0.342,0.467-0.821,0.819-1.442 c0.751-1.308,1.843-3.212,3.26-5.681l-0.009,0.089c-1.171-3.373-2.061-8.141-1.128-13.677 c0.881-5.489,3.81-11.716,9.268-16.456c2.715-2.355,6.037-4.299,9.778-5.504c3.733-1.204,7.886-1.679,12.068-1.14 c4.174,0.547,8.358,2.058,12.055,4.526c3.727,2.43,6.859,5.91,9.069,9.972c4.435,8.05,4.307,17.836,0.687,25.311 c-1.79,3.761-4.367,6.984-7.348,9.474c-2.981,2.497-6.359,4.265-9.768,5.306c-3.412,1.049-6.848,1.369-10.036,1.152 c-3.191-0.214-6.156-0.913-8.727-1.992c-5.187-2.121-8.771-5.408-11.053-8.214l0.187-0.116 c0.002,0.005,0.006,0.014,0.006,0.014c0.026,0.055,0.002,0.121-0.054,0.146c-0.019,0.009-0.042,0.012-0.062,0.009 c-3.021-0.417-5.348-0.739-6.945-0.959c-0.757-0.108-1.34-0.191-1.755-0.25 C157.623,135.221,157.439,135.186,157.439,135.186z"
    }
  })])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M180.816,118.723c0,1.46-1.183,2.643-2.643,2.643c-1.46,0-2.643-1.183-2.643-2.643 c0-1.46,1.183-2.643,2.643-2.643C179.633,116.081,180.816,117.264,180.816,118.723z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M191.392,118.723c0,1.46-1.183,2.643-2.643,2.643c-1.46,0-2.643-1.183-2.643-2.643 c0-1.46,1.183-2.643,2.643-2.643C190.209,116.081,191.392,117.264,191.392,118.723z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M201.94,117.402c0.73,1.264,0.297,2.88-0.967,3.61c-1.264,0.73-2.88,0.297-3.61-0.967 c-0.73-1.264-0.297-2.88,0.967-3.61C199.594,115.705,201.211,116.138,201.94,117.402z"
    }
  })])])])])])])])])])]), _c('g', {
    attrs: {
      "transform": "matrix(0.7148120403289795, 0, 0, 0.7148120403289795, -17.128992080688477, -16.451345443725586)"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M638.389,115.223c1.488-4.395,2.959-8.823,3.669-13.409 c0.71-4.585,0.629-9.376-0.934-13.745c-0.237-0.662-2.272-5.111-2.973-5.05c-0.501,0.043,0.736,4.185,0.477,4.617 c-2.465,4.116-3.182,9.094-2.856,13.882C636.1,106.304,637.042,110.618,638.389,115.223"
    }
  })])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ae7461"
    },
    attrs: {
      "d": "M638.22,139.007l0.843-41.481c0.52-11.626-5.811-21.619-17.447-21.817l-1.076,0.044 c-10.832,0.448-19.508,9.135-19.933,19.968c-0.395,10.079-0.703,21.221-0.413,26.607 c0.599,11.151,11.829,12.425,11.829,12.425c0.025,0,0.033,0.988,0.027,4.265l16.818,9.433l4.02-0.374L638.22,139.007z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#6f4439"
    },
    attrs: {
      "d": "M612.023,134.754c0,0,7.049,0.122,14.349-4.895c0,0-3.148,8.532-14.322,7.988 L612.023,134.754z"
    }
  })])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M603.995,105.346c0.005,0.843,0.722,1.533,1.603,1.544 c0.878,0.011,1.588-0.662,1.583-1.504c-0.005-0.843-0.722-1.534-1.601-1.545 C604.7,103.83,603.99,104.504,603.995,105.346z"
    }
  })])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M603.183,100.551c0.206,0.2,1.376-0.744,3.091-0.81 c1.712-0.091,3.007,0.739,3.184,0.521c0.088-0.096-0.129-0.464-0.693-0.84c-0.556-0.375-1.492-0.723-2.56-0.674 c-1.068,0.05-1.95,0.48-2.45,0.904C603.245,100.078,603.082,100.461,603.183,100.551z"
    }
  })])])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M618.451,105.346c0.005,0.843,0.723,1.533,1.603,1.544 c0.878,0.011,1.588-0.661,1.583-1.504c-0.005-0.842-0.723-1.534-1.601-1.545 C619.155,103.83,618.446,104.504,618.451,105.346z"
    }
  })])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M620.006,100.254c0.207,0.2,1.378-0.743,3.092-0.81 c1.711-0.091,3.006,0.739,3.184,0.521c0.087-0.097-0.128-0.463-0.694-0.84c-0.555-0.375-1.491-0.723-2.559-0.675 c-1.068,0.051-1.95,0.481-2.45,0.904C620.069,99.782,619.905,100.165,620.006,100.254z"
    }
  })])])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M614.4,113.682c0.004-0.098-1.069-0.238-2.805-0.387 c-0.44-0.027-0.858-0.097-0.944-0.393c-0.116-0.312,0.047-0.791,0.239-1.31c0.368-1.076,0.753-2.205,1.157-3.387 c1.602-4.821,2.742-8.777,2.548-8.84c-0.195-0.063-1.651,3.794-3.253,8.615c-0.384,1.189-0.752,2.321-1.102,3.405 c-0.145,0.504-0.407,1.08-0.156,1.728c0.132,0.322,0.463,0.547,0.746,0.61c0.284,0.074,0.531,0.069,0.748,0.073 C613.319,113.816,614.397,113.78,614.4,113.682z"
    }
  })])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M619.229,94.914c0.251,0.428,1.896-0.101,3.919-0.228 c2.021-0.168,3.725,0.116,3.911-0.343c0.081-0.219-0.277-0.599-1.005-0.924c-0.721-0.325-1.82-0.558-3.033-0.471 c-1.212,0.09-2.266,0.479-2.932,0.906C619.417,94.281,619.117,94.709,619.229,94.914z"
    }
  })])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M602.896,95.513c0.367,0.38,1.753-0.061,3.432-0.124 c1.677-0.113,3.108,0.18,3.425-0.236c0.138-0.201-0.096-0.586-0.727-0.938c-0.622-0.351-1.654-0.625-2.808-0.565 c-1.153,0.061-2.144,0.441-2.718,0.855C602.918,94.92,602.734,95.327,602.896,95.513z"
    }
  })])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ae7461"
    },
    attrs: {
      "d": "M638.494,105.826c0.187-0.09,7.572-2.584,7.644,5.053c0.071,7.638-7.611,6.134-7.627,5.915 C638.496,116.575,638.494,105.826,638.494,105.826z"
    }
  })])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#6f4439"
    },
    attrs: {
      "d": "M640.817,113.879c0.033-0.025,0.134,0.092,0.36,0.193c0.22,0.098,0.598,0.164,0.995,0.011 c0.804-0.304,1.471-1.591,1.496-2.968c0.013-0.695-0.139-1.356-0.39-1.901c-0.239-0.557-0.604-0.944-1.01-1.012 c-0.405-0.09-0.69,0.156-0.782,0.372c-0.1,0.214-0.05,0.366-0.091,0.38c-0.021,0.019-0.165-0.127-0.106-0.442 c0.03-0.152,0.118-0.333,0.296-0.481c0.182-0.151,0.451-0.229,0.734-0.201c0.589,0.035,1.125,0.572,1.401,1.171 c0.309,0.601,0.496,1.344,0.481,2.125c-0.035,1.539-0.809,2.987-1.91,3.316c-0.536,0.145-0.986-0.013-1.219-0.191 C640.832,114.063,640.79,113.893,640.817,113.879z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M605.542,83.066c-1.237-0.681,2.471-4.687,5.508-6.067c4.59-2.085,11.6-3.372,15.834-2.174 c5.097,1.443,9.333,3.976,11.894,8.613c2.561,4.637,3.526,10.041,3.38,15.337c-0.044,1.616-0.211,3.3-1.074,4.667 c-1.066,1.689-3.112,2.754-3.021,5.083c0.033,0.851-0.209,1.711-0.792,2.332c-1.397,1.488-3.107,0.092-3.894-1.309 c-1.68-2.991-1.87-6.562-2.019-9.989c-0.106-2.436-0.206-4.924,0.479-7.264c0.373-1.273,0.972-2.477,1.274-3.769 c0.302-1.292,0.262-2.758-0.543-3.813c-0.131-0.171-0.347-0.388-0.621-0.627c-2.164-1.895-5.192-2.46-7.903-1.5 c-4.3,1.524-11.644,3.8-13.563,2.342c-2.761-2.098-3.422-3.467-3.422-3.467L605.542,83.066z"
    }
  })])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M619.785,114.744c-0.263-0.016-0.274,1.737-1.781,2.976 c-1.504,1.242-3.373,1.037-3.388,1.282c-0.025,0.11,0.415,0.342,1.204,0.368c0.774,0.03,1.905-0.213,2.828-0.971 c0.919-0.76,1.317-1.776,1.381-2.496C620.099,115.17,619.905,114.734,619.785,114.744z"
    }
  })])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M613.89,424.128l0.357,20.229c0,0-20.442,7.157-20.739,10.902l39.247,0.716 l0.737-31.542L613.89,424.128z"
    }
  })])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0e0"
    },
    attrs: {
      "d": "M626.414,442.878c0.756,0.222,1.265,1.085,1.075,1.849 c-0.19,0.764-1.064,1.29-1.824,1.081c-0.759-0.208-1.403-1.226-1.128-1.964c0.274-0.738,1.334-1.299,2.022-0.914"
    }
  })])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M632.755,455.975l-0.05-3.182l-37.611,0.504c0,0-1.761,0.728-1.586,1.963 L632.755,455.975z"
    }
  })])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M613.614,444.146c0.003,0.192,0.96,0.296,1.891,0.929 c0.948,0.609,1.419,1.448,1.597,1.375c0.177-0.034-0.088-1.185-1.229-1.932 C614.739,443.762,613.576,443.969,613.614,444.146z"
    }
  })])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M609.467,445.773c-0.047,0.185,0.777,0.526,1.413,1.348 c0.66,0.804,0.808,1.683,1,1.678c0.179,0.034,0.332-1.086-0.478-2.094C610.6,445.691,609.474,445.59,609.467,445.773 z"
    }
  })])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M607.039,450.657c0.173,0.044,0.457-0.909-0.015-1.967 c-0.466-1.062-1.362-1.493-1.446-1.335c-0.111,0.156,0.46,0.729,0.835,1.604 C606.809,449.826,606.849,450.635,607.039,450.657z"
    }
  })])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M614.044,439.526c0.077,0.176,0.961-0.072,2.043,0.021 c1.084,0.071,1.92,0.45,2.023,0.288c0.113-0.137-0.697-0.861-1.973-0.953 C614.863,438.781,613.953,439.374,614.044,439.526z"
    }
  })])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M661.774,422.89l2.126,24.385l-3.88,19.772c-0.28,1.425,0.706,2.789,2.147,2.971l0,0 c0.807,0.102,1.607-0.187,2.157-0.787c3.498-3.814,16.298-17.909,16.042-19.685c-0.296-2.056-0.534-25.871-0.534-25.871 L661.774,422.89z"
    }
  })])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M662.166,470.018l18.094-22.121l0.066,1.035c0.057,0.895-0.2,1.781-0.737,2.5 c-1.434,1.922-5.51,7.143-15.193,17.795C663.833,469.847,662.993,470.145,662.166,470.018L662.166,470.018z"
    }
  })])])])])])])]), _c('g', {
    staticStyle: {
      "opacity": "0.6"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M674.741,440.339c-0.585,0.462-0.725,1.401-0.288,2.004 c0.438,0.603,1.391,0.754,1.984,0.302c0.593-0.452,0.796-1.573,0.293-2.124c-0.503-0.551-1.632-0.667-2.099-0.086"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M667.064,458.987c-0.134,0.077-0.767-1.168-2.264-1.763 c-1.479-0.64-2.806-0.209-2.847-0.358c-0.025-0.059,0.272-0.268,0.838-0.386c0.561-0.12,1.393-0.093,2.214,0.247 c0.82,0.342,1.427,0.911,1.739,1.393C667.062,458.605,667.124,458.963,667.064,458.987z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M665.534,462.37c-0.109,0.113-0.944-0.631-2.231-0.911 c-1.281-0.31-2.356-0.005-2.405-0.155c-0.079-0.12,1.064-0.714,2.526-0.37 C664.889,461.263,665.657,462.296,665.534,462.37z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M670.034,454.587c-0.107,0.123-1.385-1.027-3.348-1.639 c-1.953-0.643-3.662-0.45-3.678-0.612c-0.048-0.128,1.745-0.584,3.841,0.1 C668.953,453.098,670.147,454.51,670.034,454.587z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M670.007,447.12c-0.056,0.151-1.441-0.327-3.201-0.277 c-1.761,0.025-3.125,0.561-3.187,0.412c-0.075-0.115,1.283-0.918,3.176-0.95 C668.686,446.257,670.077,447.001,670.007,447.12z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M669.565,439.946c-0.067,0.146-1.476-0.581-3.325-0.378 c-1.854,0.163-3.093,1.152-3.187,1.021c-0.043-0.048,0.204-0.372,0.746-0.734c0.538-0.362,1.391-0.722,2.388-0.822 c0.997-0.096,1.904,0.089,2.503,0.339C669.292,439.621,669.598,439.89,669.565,439.946z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M666.195,438.201c-0.031,0.002-0.107-0.322-0.093-0.922 c0.016-0.595,0.132-1.477,0.579-2.467c0.235-0.471,0.472-1.072,1.134-1.437c0.328-0.184,0.838-0.154,1.148,0.151 c0.308,0.296,0.424,0.691,0.457,1.078c0.074,1.552-1.161,3.137-2.89,3.472c-1.739,0.305-3.389-0.594-4.169-1.888 c-0.174-0.337-0.306-0.755-0.143-1.18c0.16-0.428,0.646-0.626,0.999-0.588c0.733,0.062,1.217,0.45,1.663,0.733 c0.885,0.623,1.452,1.301,1.789,1.791c0.339,0.493,0.457,0.805,0.43,0.82c-0.082,0.07-0.694-1.16-2.429-2.295 c-0.436-0.259-0.94-0.589-1.465-0.604c-0.256-0.009-0.469,0.107-0.546,0.317c-0.081,0.203-0.01,0.506,0.139,0.77 c0.656,1.058,2.167,1.875,3.633,1.595c1.46-0.267,2.544-1.662,2.496-2.912c-0.016-0.301-0.115-0.598-0.287-0.766 c-0.169-0.165-0.413-0.198-0.632-0.092c-0.463,0.222-0.749,0.755-0.982,1.199 C666.11,436.836,666.305,438.219,666.195,438.201z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M594.814,255.21c0,0-2.976,11.523-1.896,25.562c0.418,5.432,18.749,155.715,18.749,155.715 h24.751l-6.957-141.245l2.027,0.44c0,0,13.511,60.241,14.613,69.994c0.991,8.766,12.385,72.457,12.385,72.457l22.63,0.26 l-7.227-84.244l-8.411-80.834l-3.164-23.53L594.814,255.21z"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M633.362,280.833c0.014,0.032-0.349,0.244-1.033,0.582c-0.686,0.323-1.695,0.817-3.065,1.073 c-0.684,0.125-1.462,0.161-2.28,0.016c-0.812-0.144-1.681-0.49-2.384-1.145c-0.703-0.656-1.157-1.574-1.446-2.527 c-0.292-0.962-0.459-1.962-0.663-2.978c-0.79-4.076-1.324-7.799-1.635-10.5c-0.156-1.351-0.26-2.446-0.316-3.205 c-0.055-0.759-0.067-1.18-0.031-1.184c0.036-0.004,0.116,0.41,0.234,1.16c0.13,0.86,0.291,1.923,0.481,3.179 c0.405,2.683,0.996,6.385,1.783,10.45c0.399,2.009,0.671,4.056,1.927,5.254c1.254,1.176,2.999,1.3,4.273,1.112 c1.316-0.197,2.336-0.629,3.042-0.893C632.953,280.949,633.347,280.798,633.362,280.833z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M625.913,261.676c-0.008-0.023,0.16-0.129,0.509-0.151c0.344-0.026,0.868,0.079,1.385,0.445 c0.495,0.364,1.021,1.019,1.043,1.912c0.041,0.904-0.665,1.794-1.585,2.125c-0.911,0.356-2.028,0.15-2.593-0.558 c-0.571-0.687-0.605-1.526-0.472-2.126c0.148-0.615,0.474-1.039,0.75-1.246c0.277-0.213,0.473-0.243,0.482-0.221 c0.068,0.068-0.696,0.415-0.869,1.536c-0.076,0.529,0.011,1.23,0.47,1.737c0.442,0.519,1.29,0.672,2.046,0.386 c0.757-0.282,1.296-0.955,1.287-1.637c0.013-0.684-0.384-1.269-0.788-1.618C626.711,261.531,625.906,261.772,625.913,261.676z "
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff725e"
    },
    attrs: {
      "d": "M606.188,143.79c-4.724,0.291-13.275,3.135-16.895,9.896c-3.026,5.652-3.851,29.804-4.014,30.38 l9.104,2.36l11.626,17.197l47.613-10.623l2.981,7.507l1.829-53.758C658.432,146.749,610.913,143.499,606.188,143.79z"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff725e"
    },
    attrs: {
      "d": "M661.491,225.066l3.644-51.369l-0.846-24.366l-22.264-9.816l-2.213-8.517l-23.052,10.898 l-4.828-5.335l-2.022,6.013l-5.051,1.651l-11.77,20.096l0.171,33.627c0,0-1.238,41.074-0.25,55.36 c0.122,1.773,1.287,3.31,2.969,3.883c2.335,0.796,6.335,1.711,12.611,1.863c23.222,0.56,54.849-0.908,54.849-0.908 l0.324-1.016c0.904-2.833,1.172-5.831,0.785-8.779L661.491,225.066z"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M613.715,153.283c0.324-1.289,0.581-2.312,0.77-3.066c0.086-0.317,0.157-0.578,0.216-0.793 c0.052-0.178,0.084-0.268,0.094-0.265c0.01,0.002-0.001,0.097-0.033,0.28c-0.042,0.22-0.094,0.485-0.157,0.808 c-0.162,0.761-0.381,1.792-0.658,3.093c-0.579,2.684-1.445,6.561-2.408,11.373c-0.947,4.812-2.013,10.567-2.726,17.01 c-0.683,6.443-0.918,13.587-1.009,21.077c-0.154,14.982,0.243,28.549,0.497,38.366c0.134,4.866,0.243,8.823,0.32,11.629 c0.027,1.33,0.048,2.385,0.063,3.163c0.001,0.329,0.001,0.6,0.001,0.824c-0.003,0.186-0.01,0.281-0.02,0.281 c-0.011,0.001-0.025-0.094-0.042-0.278c-0.017-0.223-0.037-0.492-0.062-0.82c-0.044-0.777-0.103-1.83-0.178-3.158 c-0.124-2.803-0.299-6.759-0.514-11.621c-0.365-9.816-0.831-23.385-0.676-38.388c0.091-7.502,0.343-14.658,1.061-21.138 c0.747-6.472,1.86-12.227,2.863-17.037"
    }
  })])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff725e"
    },
    attrs: {
      "d": "M639.811,130.998c0,0-2.578,0.746-9.197,4.278c-6.485,3.46-13.855,6.62-13.855,6.62 l0.56,10.409l24.532-12.316"
    }
  })])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('polyline', {
    staticStyle: {
      "fill": "#ff725e"
    },
    attrs: {
      "points": "611.931,136.561 616.76,141.896 614.179,153.054 609.878,142.969 &#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;"
    }
  })])])])])]), _c('g', {
    staticStyle: {
      "opacity": "0.3"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M616.67,143.048c-0.214,0.16-1.554,12.877-1.554,12.877l24.59-14.857l-22.385,11.238L616.67,143.048z"
    }
  })])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M616.991,141.806c0.042,0.029-0.473,0.818-1.252,2.121c-0.779,1.303-1.809,3.132-2.792,5.228 c-0.08,0.172-0.159,0.343-0.233,0.503l-0.153,0.33l-0.156-0.328c-0.946-1.992-1.63-3.845-2.053-5.198 c-0.213-0.677-0.365-1.228-0.459-1.611c-0.094-0.383-0.132-0.597-0.111-0.603c0.047-0.014,0.31,0.812,0.791,2.139 c0.479,1.327,1.194,3.152,2.139,5.126l-0.309,0.003c0.074-0.161,0.154-0.333,0.234-0.507 c0.989-2.111,2.061-3.934,2.896-5.21c0.417-0.639,0.773-1.143,1.029-1.485C616.819,141.973,616.972,141.793,616.991,141.806 z"
    }
  })])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M642.024,139.515c0.005,0.011-0.111,0.08-0.337,0.202c-0.26,0.136-0.59,0.308-0.995,0.52 c-0.906,0.469-2.148,1.113-3.665,1.899c-3.092,1.608-7.326,3.899-12.018,6.406c-2.857,1.522-5.564,2.933-7.919,4.111 l-0.217,0.109l-0.003-0.241c-0.03-3.054-0.055-5.627-0.073-7.488c0.002-0.874,0.003-1.58,0.004-2.111 c0.006-0.488,0.018-0.749,0.034-0.75c0.016,0,0.037,0.26,0.061,0.748c0.02,0.53,0.047,1.235,0.08,2.109 c0.049,1.86,0.116,4.433,0.197,7.485l-0.219-0.132c2.341-1.199,5.038-2.621,7.895-4.143c4.69-2.506,8.946-4.765,12.069-6.32 c1.56-0.78,2.832-1.391,3.716-1.803c0.417-0.189,0.756-0.342,1.024-0.463C641.893,139.553,642.019,139.504,642.024,139.515z "
    }
  })])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ae7461"
    },
    attrs: {
      "d": "M613.693,143.705c-0.644-3.3-0.322-7.084-0.322-7.084s1.61-4.589,1.369-5.394 c-0.242-0.805-0.644-1.69-2.254-0.885c-1.61,0.805-3.623,2.254-3.864,4.911c-0.242,2.656-0.644,3.622-0.644,3.622 l-1.53-2.334l0.322-2.415c0,0,2.272-0.572,2.35-1.787c0.007-0.118-2.296-1.633-2.296-1.633s-4.079,0.201-4.482,1.73 c-0.403,1.529-1.449,4.83-1.449,4.83s-3.381,0.564-3.784,3.301c0,0-1.932,2.576-1.851,4.186c0,0-1.047,1.851-0.966,3.381 c0.08,1.529,4.508,7.969,4.508,7.969l1.351,10.096l12.434-4.206l-0.825-9.191 C611.761,152.801,614.337,147.005,613.693,143.705z"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#6f4439"
    },
    attrs: {
      "d": "M613.693,143.644c0.013-0.003,0.054,0.208,0.121,0.622c0.033,0.416,0.066,1.04-0.031,1.842 c-0.172,1.606-0.738,3.918-1.89,6.691l0.012-0.071c0.245,2.573,0.541,5.68,0.874,9.186l0.016,0.163l-0.16,0.042 c-3.747,0.988-7.968,2.101-12.549,3.309l-0.256,0.067l-0.036-0.263c-0.393-2.898-0.81-5.97-1.242-9.158l0.042,0.108 c-1.138-1.676-2.281-3.419-3.343-5.282c-0.265-0.466-0.518-0.945-0.756-1.439c-0.213-0.484-0.486-1.045-0.463-1.661 c0.057-1.167,0.473-2.224,1-3.238l-0.033,0.14c-0.014-0.631,0.182-1.242,0.421-1.814c0.399-0.918,0.911-1.747,1.482-2.54 l-0.049,0.118c0.142-0.973,0.716-1.845,1.47-2.411c0.763-0.564,1.616-0.917,2.528-1.104l-0.202,0.175 c0.505-1.667,1.003-3.307,1.491-4.916c0.191-0.503,0.613-0.785,0.996-0.992c0.396-0.204,0.807-0.331,1.215-0.444 c0.822-0.209,1.636-0.322,2.461-0.375l0.08-0.005l0.067,0.045c0.425,0.287,0.846,0.571,1.265,0.854l0.619,0.438l0.308,0.236 l0.084,0.074c0.022,0.025,0.011,0.002,0.061,0.066c0.049,0.054,0.071,0.194,0.062,0.196l-0.04,0.227 c-0.181,0.6-0.658,0.939-1.09,1.196c-0.452,0.252-0.911,0.431-1.4,0.564l0.174-0.195c-0.112,0.822-0.221,1.624-0.328,2.414 l-0.035-0.154c0.521,0.8,1.027,1.577,1.523,2.339l-0.386,0.036c0.298-0.875,0.438-1.854,0.555-2.77 c0.081-0.906,0.197-1.91,0.642-2.727c0.87-1.672,2.399-2.673,3.876-3.299c0.382-0.137,0.848-0.229,1.268-0.015 c0.416,0.221,0.595,0.639,0.714,0.989c0.058,0.154,0.12,0.412,0.09,0.594c-0.005,0.197-0.044,0.371-0.072,0.551 c-0.068,0.353-0.149,0.692-0.238,1.021c-0.356,1.314-0.752,2.483-1.121,3.529l0.007-0.031 c-0.174,2.287-0.093,4.068,0.002,5.26c0.052,0.597,0.107,1.049,0.148,1.352 C613.688,143.486,613.704,143.642,613.693,143.644c-0.011,0.002-0.049-0.15-0.113-0.45c-0.063-0.301-0.139-0.752-0.213-1.35 c-0.137-1.196-0.26-2.979-0.121-5.294l0.001-0.014l0.006-0.017c0.348-1.045,0.727-2.22,1.061-3.522 c0.084-0.325,0.159-0.66,0.22-1c0.024-0.168,0.06-0.345,0.06-0.509c0.021-0.178-0.015-0.283-0.078-0.472 c-0.113-0.33-0.279-0.654-0.558-0.791c-0.275-0.143-0.645-0.087-0.991,0.044c-1.383,0.6-2.862,1.598-3.638,3.143 c-0.407,0.777-0.501,1.637-0.582,2.597c-0.119,0.946-0.234,1.894-0.567,2.89l-0.138,0.412l-0.248-0.376 c-0.5-0.759-1.011-1.533-1.536-2.33l-0.046-0.07l0.011-0.084c0.103-0.79,0.208-1.593,0.316-2.416l0.02-0.153l0.154-0.042 c0.434-0.12,0.88-0.296,1.278-0.522c0.392-0.227,0.762-0.536,0.863-0.908l0.025-0.139l0.001-0.005l0.001-0.002 c-0.049-0.004,0.435,0.026,0.224,0.013l-0.012-0.001c-0.031-0.003-0.062,0.001-0.091,0.011 c-0.044,0.009-0.14,0.09-0.098,0.099c0.033,0.037-0.005,0-0.005,0l-0.056-0.048l-0.286-0.217l-0.61-0.428 c-0.416-0.279-0.836-0.56-1.259-0.844l0.146,0.04c-0.781,0.052-1.586,0.167-2.359,0.367 c-0.737,0.202-1.614,0.514-1.863,1.123c-0.483,1.605-0.975,3.24-1.476,4.903l-0.043,0.143l-0.159,0.033 c-0.805,0.165-1.627,0.505-2.298,1.008c-0.671,0.51-1.146,1.243-1.271,2.077l-0.01,0.063l-0.04,0.055 c-0.542,0.752-1.047,1.573-1.419,2.433c-0.227,0.534-0.392,1.097-0.38,1.584l0.002,0.074l-0.035,0.067 c-0.492,0.936-0.891,1.981-0.936,2.996c-0.02,0.485,0.199,0.938,0.413,1.43c0.229,0.476,0.476,0.945,0.736,1.406 c1.045,1.84,2.184,3.585,3.309,5.25l0.034,0.051l0.008,0.058c0.421,3.189,0.827,6.263,1.21,9.162l-0.291-0.195 c4.588-1.179,8.816-2.266,12.569-3.231l-0.144,0.205c-0.296-3.509-0.558-6.62-0.775-9.195l-0.003-0.037l0.015-0.035 c1.176-2.725,1.785-5.014,2.001-6.592C613.873,144.503,613.642,143.648,613.693,143.644z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#6f4439"
    },
    attrs: {
      "d": "M610.647,143.341c-0.127,0.065-0.9-1.025-1.725-2.435c-0.826-1.411-1.395-2.614-1.272-2.688 c0.123-0.074,0.895,1.016,1.725,2.436C610.204,142.072,610.774,143.275,610.647,143.341z"
    }
  })])])])]), _c('g', {
    staticStyle: {
      "opacity": "0.3"
    }
  }, [_c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M620.864,216.094c9.044-0.088,18.029-3.297,25.082-8.959c7.053-5.661,12.13-13.739,14.172-22.55L620.864,216.094z"
    }
  })])])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff725e"
    },
    attrs: {
      "d": "M612.956,161.514l11.457,31.118l24.269-36.314c0,0,11.623-13.038,17.087-5.347 c5.464,7.69,2.684,22.249-0.778,29.156c-3.223,6.431-33.034,44.493-38.498,45.1c-5.464,0.607-13.701-1.495-17.344-8.376 c-3.643-6.881-16.042-48.834-16.042-48.834L612.956,161.514z"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M662.6,149.443c0,0.167-2.645-0.102-5.643,0.97c-3.013,1.031-4.913,2.89-5.017,2.76 c-0.111-0.059,1.701-2.169,4.846-3.25C659.918,148.808,662.65,149.327,662.6,149.443z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff725e"
    },
    attrs: {
      "d": "M665.448,179.4c-3.116,6.431-31.932,44.493-37.214,45.1 c-5.282,0.607-13.244-1.495-16.765-8.376c-3.521-6.881-15.69-49.578-15.69-49.578l19.37-5.76l11.075,31.118l23.459-36.314"
    }
  })]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M649.683,155.591c0,0-0.125,0.232-0.395,0.667c-0.282,0.45-0.685,1.091-1.206,1.92 c-1.08,1.696-2.651,4.162-4.66,7.315c-4.067,6.334-9.903,15.424-17.028,26.522l-0.224,0.349l-0.14-0.391 c-3.274-9.162-7.036-19.691-11.114-31.104l0.302,0.153c-6.207,1.849-12.686,3.78-19.367,5.77l0.174-0.317 c1.541,5.275,3.156,10.805,4.8,16.434c2.234,7.518,4.465,14.843,6.75,21.873c1.17,3.501,2.285,6.971,3.664,10.221 c1.318,3.272,3.89,5.829,6.873,7.344c2.982,1.53,6.319,2.185,9.481,1.973l0.592-0.046l0.514-0.147 c0.334-0.183,0.679-0.34,0.991-0.581c0.323-0.213,0.634-0.447,0.932-0.699c0.306-0.239,0.602-0.49,0.888-0.754 c1.163-1.026,2.242-2.117,3.285-3.205c4.151-4.377,7.737-8.723,10.98-12.704c6.453-7.995,11.418-14.671,14.752-19.349 c1.665-2.341,2.916-4.188,3.728-5.463c0.411-0.635,0.702-1.132,0.896-1.467c0.188-0.338,0.297-0.506,0.297-0.506 s-0.077,0.184-0.25,0.531c-0.179,0.345-0.457,0.852-0.854,1.497c-0.784,1.296-2.01,3.164-3.651,5.525 c-3.286,4.719-8.209,11.432-14.631,19.464c-3.229,4.001-6.8,8.362-10.955,12.771c-1.044,1.096-2.125,2.197-3.301,3.24 c-0.288,0.267-0.589,0.524-0.902,0.77c-0.302,0.257-0.622,0.499-0.96,0.724c-0.318,0.246-0.699,0.428-1.066,0.625 c-0.211,0.063-0.428,0.132-0.64,0.182l-0.61,0.05c-3.255,0.224-6.662-0.437-9.735-2.003c-3.068-1.545-5.75-4.208-7.107-7.567 c-1.405-3.299-2.518-6.756-3.695-10.266c-2.294-7.036-4.529-14.363-6.764-21.883c-1.67-5.624-3.285-11.155-4.796-16.442 l-0.07-0.245l0.244-0.072c6.683-1.983,13.165-3.906,19.373-5.749l0.224-0.066l0.078,0.22 c4.049,11.423,7.785,21.962,11.035,31.132l-0.364-0.042c7.188-11.057,13.075-20.115,17.177-26.425 c2.049-3.127,3.651-5.573,4.753-7.255c0.542-0.816,0.961-1.446,1.255-1.889C649.523,155.801,649.683,155.591,649.683,155.591 z"
    }
  })])])])]), _c('g', {
    staticStyle: {
      "opacity": "0.3"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M645.779,219.029c-0.494-0.549-1.302-0.653-2.037-0.718c-12.655-1.13-25.393-1.324-38.076-0.581l-12.885,9.85 c-0.189,0.411,0.067,0.915,0.449,1.157c0.381,0.242,0.851,0.288,1.301,0.327c3.348,0.292,6.696,0.585,10.045,0.877 c3.097,0.27,6.203,0.541,9.31,0.436c1.937-0.065,3.87-0.277,5.808-0.27c3.216,0.012,6.395,0.623,9.592,0.966 c2.538,0.272,5.123,0.374,7.628-0.118c2.505-0.492,4.942-1.621,6.661-3.508c1.58-1.735,2.477-4.04,2.662-6.38 C646.291,220.354,646.258,219.562,645.779,219.029z"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ae7461"
    },
    attrs: {
      "d": "M645.965,217.738c-0.404-0.202-5.698-2.354-5.698-2.354l-6.806-1.353l6.539-0.262l5.712,1.591 c0,0,2.279,0.258,1.771-1.66c-0.507-1.918-7.473-4.038-7.473-4.038l-8.884-0.611c0,0,6.865-1.004,7.572-3.124 c0.707-2.12-0.505-3.331-0.505-3.331s-4.846,1.918-7.168,2.322c-2.322,0.404-5.149,1.312-8.884,2.827 c-3.735,1.514-5.922,2.726-5.922,2.726l-3.769,13.124c0,0,6.259,3.937,13.326,3.735c7.067-0.202,13.326,2.081,14.234,1.445 c0.909-0.637,1.01-1.747,0-2.252c-1.009-0.505-5.289-1.11-5.289-1.11l-3.695-1.514c0,0,12.619,1.111,13.628,0.606 c1.01-0.505,2.019-1.212,1.615-2.322c-0.404-1.11-1.413-1.11-1.413-1.11s2.726,0.101,2.625-1.01 C647.379,218.95,646.369,217.94,645.965,217.738z"
    }
  })]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#6f4439"
    },
    attrs: {
      "d": "M631.349,219.08c0.001,0.057,0.813,0.083,2.12,0.163c1.307,0.079,3.108,0.232,5.081,0.529 c1.973,0.3,3.739,0.688,5.01,1c1.272,0.311,2.055,0.528,2.073,0.473c0.015-0.045-0.74-0.353-2.002-0.732 c-1.261-0.381-3.034-0.814-5.024-1.117c-1.99-0.3-3.811-0.412-5.128-0.422C632.161,218.963,631.348,219.032,631.349,219.08z"
    }
  })])])])]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff725e"
    },
    attrs: {
      "d": "M594.031,205.56l-1.633-34.725l-3.665-15.829l-12.901,35.553l-4.357,15.926 c-3.212,15.08,9.226,20.808,14.511,20.613l27.633,1.001l2.599-17.63L594.031,205.56z"
    }
  })]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff725e"
    },
    attrs: {
      "d": "M593.59,205.011c-0.522-11.715-1.043-23.43-1.565-35.145"
    }
  })]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M592.026,169.867c0.144-0.006,0.611,7.856,1.043,17.56c0.432,9.707,0.666,17.578,0.522,17.585 c-0.144,0.006-0.61-7.855-1.043-17.562C592.116,177.746,591.882,169.873,592.026,169.867z"
    }
  })])])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M584.571,227c0.001-0.014,0.191-0.022,0.557-0.022c0.409,0.005,0.943,0.012,1.611,0.02 c1.456,0.038,3.494,0.091,6.033,0.156c5.202,0.174,12.448,0.416,20.857,0.697l-0.255,0.214 c0.525-3.864,1.096-8.063,1.689-12.42c0.263-1.917,0.523-3.804,0.769-5.597l0.198,0.286c-4.955-1.131-9.631-2.164-13.86-3.057 c-2.115-0.443-4.119-0.851-5.992-1.194c-1.874-0.351-3.612-0.607-5.215-0.566c-3.206,0.012-5.718,0.885-7.178,1.868 c-1.489,0.967-2.001,1.855-2.056,1.799c-0.013-0.01,0.13-0.207,0.419-0.579c0.31-0.35,0.785-0.869,1.533-1.375 c1.458-1.053,4.016-2,7.277-2.057c1.627-0.065,3.414,0.176,5.292,0.509c1.884,0.326,3.894,0.717,6.014,1.146 c4.24,0.865,8.922,1.879,13.883,3.002l0.23,0.052l-0.032,0.234c-0.245,1.794-0.502,3.68-0.764,5.598 c-0.601,4.356-1.18,8.554-1.713,12.417l-0.031,0.224l-0.225-0.009c-8.406-0.356-15.65-0.663-20.85-0.883 c-2.536-0.126-4.572-0.228-6.027-0.3c-0.667-0.042-1.199-0.076-1.608-0.101C584.76,227.036,584.57,227.014,584.571,227z"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff725e"
    },
    attrs: {
      "d": "M626.283,191.567c1.906,3.683,3.032,7.768,3.283,11.908"
    }
  })]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M629.566,203.475c-0.159,0.011-0.354-2.771-1.272-6.055c-0.896-3.292-2.154-5.78-2.011-5.852 c0.108-0.07,1.597,2.354,2.513,5.714C629.732,200.634,629.695,203.479,629.566,203.475z"
    }
  })])])]), _c('g', {
    staticStyle: {
      "opacity": "0.3"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M593.307,205.029c-2.129-0.65-4.284-1.283-6.503-1.451c-2.219-0.168-4.535,0.16-6.436,1.317 c-0.619,0.377-1.208,0.862-1.506,1.522c-0.298,0.661-0.233,1.525,0.308,2.008c0.487,0.435,1.231,0.462,1.852,0.259 c0.62-0.203,1.155-0.601,1.703-0.955c2.923-1.887,6.556-2.644,9.989-2.081"
    }
  })])])])]), _c('g', {
    attrs: {
      "transform": "matrix(0.7148120403289795, 0, 0, 0.7148120403289795, -17.128992080688477, -16.451345443725586)"
    }
  }, [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M102.207,98.199c-1.362-3.023-5.383-4.035-8.566-3.109c-2.859,0.832-5.322,2.936-6.59,5.63 c-1.354,2.877-1.339,6.18-1.412,9.359c-0.243,10.605-1.746,21.14-2.324,31.732c-0.578,10.591-0.195,21.417,3.211,31.462 l19.029-1.419l7.081-3.219L102.207,98.199z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M140.685,102.633c-1.222-1.776-2.705-3.341-4.614-4.343c-3.001-1.576-5.633-3.794-8.659-5.322 c-7.461-3.766-16.99-2.744-23.717,2.215c-6.727,4.959-10.499,13.527-10.009,21.87c0.491,8.343,5.088,16.265,11.859,21.164 l32.728-7.974c2.046-5.546,2.941-10.863,3.589-17.579C142.089,110.293,141.734,104.158,140.685,102.633z"
    }
  })]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffbf9d"
    },
    attrs: {
      "d": "M101.578,114.103c0.383-5.409,3.884-9.845,9.138-11.186l16.377-4.178 c7.078-0.765,11.804,7.942,12.268,15.046c0.515,7.892,0.832,16.221-0.09,22.113 c-1.854,11.847-10.928,13.374-10.928,13.374c-0.001-0.018-0.002,5.634-0.008,9.093l0.17,15.057l-23.313-16.766 l-3.655-42.41C101.532,114.044,101.559,114.373,101.578,114.103z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M136.715,122.948c0.03,0.802-0.624,1.489-1.461,1.536 c-0.835,0.047-1.538-0.564-1.569-1.366c-0.03-0.802,0.624-1.49,1.459-1.536 C135.982,121.535,136.685,122.146,136.715,122.948z"
    }
  })])])])])])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M137.336,118.66c-0.188,0.199-1.34-0.65-2.975-0.643 c-1.633-0.016-2.83,0.828-3.008,0.628c-0.087-0.088,0.104-0.446,0.625-0.828 c0.513-0.38,1.389-0.75,2.407-0.748c1.018,0.003,1.875,0.376,2.368,0.759 C137.257,118.214,137.428,118.572,137.336,118.66z"
    }
  })])])])])])])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M122.212,123.311c0.03,0.802-0.624,1.489-1.461,1.535 c-0.835,0.047-1.538-0.564-1.569-1.366c-0.03-0.802,0.624-1.49,1.46-1.536 C121.479,121.897,122.182,122.508,122.212,123.311z"
    }
  })])])])])])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M122.135,118.966c-0.189,0.199-1.342-0.65-2.976-0.642 c-1.632-0.016-2.83,0.828-3.008,0.628c-0.087-0.088,0.102-0.446,0.625-0.827 c0.513-0.38,1.389-0.75,2.407-0.749c1.018,0.004,1.875,0.377,2.369,0.759 C122.055,118.52,122.227,118.878,122.135,118.966z"
    }
  })])])])])])])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M127.171,131.262c-0.007-0.093,1.008-0.27,2.654-0.485 c0.417-0.044,0.812-0.128,0.882-0.413c0.098-0.302-0.078-0.751-0.281-1.236 c-0.395-1.009-0.808-2.067-1.241-3.175c-1.724-4.521-2.973-8.239-2.79-8.306 c0.183-0.068,1.729,3.541,3.452,8.062c0.415,1.115,0.812,2.177,1.189,3.194 c0.159,0.474,0.432,1.011,0.22,1.638c-0.112,0.312-0.417,0.539-0.685,0.612 c-0.267,0.082-0.502,0.087-0.709,0.1C128.205,131.345,127.177,131.355,127.171,131.262z"
    }
  })])])])])])])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff9a6c"
    },
    attrs: {
      "d": "M112.635,145.058c0,0,3.854,8.135,15.705,7l0.004-2.786 C128.343,149.273,120.539,149.785,112.635,145.058z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M121.549,112.52c-0.16,0.445-1.793,0.238-3.709,0.473 c-1.922,0.197-3.467,0.762-3.722,0.364c-0.114-0.19,0.155-0.609,0.779-1.041 c0.619-0.431,1.607-0.841,2.758-0.972c1.151-0.128,2.205,0.052,2.904,0.335 C121.262,111.96,121.617,112.308,121.549,112.52z"
    }
  })])])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M135.617,112.749c-0.287,0.372-1.413-0.011-2.767-0.026 c-1.353-0.063-2.5,0.255-2.765-0.133c-0.116-0.188,0.064-0.56,0.564-0.913 c0.493-0.351,1.318-0.639,2.248-0.613c0.93,0.028,1.737,0.362,2.209,0.742 C135.586,112.186,135.744,112.568,135.617,112.749z"
    }
  })])])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffbf9d"
    },
    attrs: {
      "d": "M103.2,122.684c-0.125-0.34-6.302-2.569-6.384,3.997 c-0.079,6.379,6.357,5.123,6.37,4.94C103.198,131.438,103.2,122.684,103.2,122.684z"
    }
  })])])])])])])])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff9a6c"
    },
    attrs: {
      "d": "M101.24,129.186c-0.028-0.02-0.112,0.077-0.301,0.161 c-0.184,0.082-0.499,0.137-0.831,0.01c-0.672-0.254-1.229-1.329-1.249-2.479 c-0.011-0.581,0.116-1.132,0.326-1.588c0.199-0.465,0.504-0.788,0.844-0.845 c0.338-0.075,0.577,0.131,0.653,0.311c0.084,0.179,0.042,0.306,0.076,0.317 c0.018,0.016,0.138-0.106,0.089-0.369c-0.025-0.127-0.098-0.278-0.247-0.402 c-0.152-0.126-0.376-0.191-0.613-0.168c-0.493,0.029-0.939,0.478-1.17,0.978 c-0.258,0.502-0.414,1.122-0.402,1.774c0.029,1.286,0.676,2.495,1.595,2.77 c0.448,0.122,0.823-0.01,1.018-0.159C101.227,129.34,101.262,129.198,101.24,129.186z"
    }
  })])])])])])])])])])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M100.515,130.314c-0.621-0.116-1.294,0.317-1.448,0.929 c-0.154,0.613,0.235,1.312,0.837,1.503c0.602,0.192,1.324-0.153,1.553-0.742c0.229-0.589-0.071-1.331-0.644-1.596"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M100.813,130.408c-0.037,0.038,0.416,0.221,0.574,0.857 c0.074,0.304,0.034,0.707-0.249,1.001c-0.268,0.294-0.752,0.478-1.189,0.341c-0.435-0.141-0.725-0.571-0.773-0.966 c-0.06-0.404,0.14-0.756,0.376-0.961c0.497-0.427,0.972-0.315,0.964-0.367c0.004-0.016-0.098-0.066-0.299-0.07 c-0.198-0.005-0.502,0.056-0.796,0.278c-0.29,0.21-0.57,0.64-0.511,1.15c0.047,0.49,0.381,1.023,0.951,1.213 c0.575,0.174,1.156-0.067,1.477-0.44c0.343-0.382,0.363-0.896,0.248-1.234c-0.111-0.352-0.324-0.576-0.488-0.687 C100.931,130.411,100.819,130.393,100.813,130.408z"
    }
  })])])])])])])])])])])])])]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M130.173,97.836c-0.398-0.715-1.324-0.907-2.137-0.995c-11.329-1.227-23.139,3.864-30.025,12.943 l1.819,11.029c-0.772,1.372,2.851,4.131,4.422,4.033c1.571-0.098,2.797-1.474,3.356-2.945c1.094-2.878,0.469-6.564,2.718-8.667 c1.268-1.185,3.098-1.479,4.793-1.852c3.231-0.71,6.388-1.914,9.078-3.839c2.69-1.926,4.895-4.609,5.936-7.749 C130.345,99.155,130.5,98.423,130.173,97.836z"
    }
  })]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M96.376,126.163c-0.028,0.013-0.265-0.39-0.62-1.156c-0.357-0.766-0.803-1.909-1.205-3.37 c-0.815-2.901-1.302-7.189-0.317-11.742c0.983-4.555,3.197-8.26,5.137-10.565c0.969-1.164,1.848-2.021,2.488-2.572 c0.64-0.552,1.022-0.821,1.042-0.797c0.071,0.076-1.401,1.243-3.243,3.599c-1.84,2.332-3.953,5.988-4.915,10.445 c-0.963,4.455-0.548,8.657,0.165,11.541C95.613,124.453,96.472,126.123,96.376,126.163z"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M126.378,93.341c0.021-0.057,0.455,0.021,1.065,0.376c0.608,0.35,1.358,1.02,1.899,1.96 c0.537,0.942,0.735,1.929,0.729,2.63c-0.003,0.706-0.156,1.12-0.215,1.108c-0.155-0.004,0.064-1.731-0.965-3.48 C127.903,94.163,126.302,93.477,126.378,93.341z"
    }
  })])]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff9a6c"
    },
    attrs: {
      "d": "M125.874,134.305l-0.099-0.204c-1.084-0.353-2.167-0.707-3.251-1.06 c-0.298-0.097-0.615-0.196-0.923-0.129c-0.333,0.072-0.59,0.327-0.77,0.603c-0.613,0.945-0.457,2.275,0.351,3.078 c0.808,0.803,2.19,1.013,3.229,0.502C125.451,136.584,126.066,135.4,125.874,134.305z"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('polygon', {
    staticStyle: {
      "fill": "#ffbf9d"
    },
    attrs: {
      "points": "104.07,419.65 107.823,452.029 122.012,449.869 122.968,417.958 &#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#10;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;"
    }
  })])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M122.061,443.451c0,0-9.524,8.077-14.83,2.142l-1.054,3.158l-4.169,22.241 c-0.27,1.44,0.487,2.944,1.853,3.373c1.052,0.33,2.163,0.011,2.881-0.8c3.845-4.343,17.914-20.39,17.624-22.395 l-0.436-5.347C123.84,444.714,123.1,443.775,122.061,443.451L122.061,443.451z"
    }
  })])])])])])])]), _c('g', {
    staticStyle: {
      "opacity": "0.6"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M104.365,474.474l19.878-25.166l0.078,1.169c0.197,1.259-0.308,1.802-0.839,2.659 c-1.572,2.541-6.015,8.297-16.657,20.424C106.206,474.266,105.28,474.611,104.365,474.474L104.365,474.474z"
    }
  })])])])])])])]), _c('g', {
    staticStyle: {
      "opacity": "0.6"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M120.842,446.072c-0.644,0.528-0.795,1.59-0.308,2.268 c0.486,0.678,1.539,0.841,2.192,0.324c0.652-0.516,0.872-1.786,0.315-2.403c-0.558-0.618-1.805-0.739-2.318-0.078"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M109.724,461.961c-0.147,0.088-0.852-1.313-2.507-1.972 c-1.636-0.71-3.099-0.211-3.145-0.379c-0.028-0.066,0.299-0.306,0.924-0.443c0.619-0.141,1.537-0.117,2.446,0.259 c0.907,0.379,1.579,1.017,1.926,1.559C109.72,461.529,109.789,461.934,109.724,461.961z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M108.05,465.798c-0.12,0.129-1.045-0.704-2.467-1.01 c-1.415-0.338-2.601,0.016-2.656-0.153c-0.087-0.135,1.172-0.816,2.787-0.44 C107.332,464.553,108.185,465.714,108.05,465.798z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M112.983,456.961c-0.118,0.14-1.535-1.148-3.704-1.823 c-2.16-0.709-4.045-0.475-4.063-0.659c-0.053-0.144,1.924-0.675,4.242,0.079 C111.783,455.287,113.108,456.874,112.983,456.961z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M112.993,450.289c-0.061,0.171-1.593-0.356-3.536-0.285 c-1.944,0.044-3.448,0.662-3.517,0.495c-0.083-0.13,1.413-1.049,3.502-1.102 C111.53,449.325,113.069,450.155,112.993,450.289z"
    }
  })])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M108.349,450.03c-0.034-0.003-0.054-0.38,0.078-1.044 c0.133-0.659,0.431-1.619,1.109-2.634c0.347-0.478,0.722-1.102,1.511-1.38c0.393-0.141,0.941-0.008,1.219,0.392 c0.277,0.389,0.326,0.852,0.287,1.289c-0.221,1.743-1.871,3.267-3.816,3.303c-1.949,0-3.568-1.321-4.163-2.914 c-0.124-0.409-0.186-0.901,0.074-1.342c0.257-0.446,0.823-0.571,1.2-0.461c0.784,0.211,1.235,0.738,1.665,1.14 c0.841,0.866,1.325,1.731,1.596,2.342c0.272,0.615,0.34,0.985,0.308,0.997c-0.102,0.061-0.529-1.427-2.194-3.028 c-0.423-0.373-0.907-0.839-1.475-0.958c-0.277-0.06-0.53,0.027-0.655,0.247c-0.127,0.211-0.109,0.562,0.002,0.885 c0.508,1.306,1.99,2.51,3.638,2.483c1.639-0.013,3.088-1.356,3.279-2.757c0.041-0.338-0.009-0.688-0.163-0.909 c-0.152-0.217-0.411-0.301-0.669-0.226c-0.546,0.157-0.961,0.695-1.3,1.144 C108.522,448.494,108.465,450.071,108.349,450.03z"
    }
  })])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffbf9d"
    },
    attrs: {
      "d": "M160.289,445.163c-0.327-0.5-3.301-11.335-3.301-11.335l18.369-5l2.604,15.616L160.289,445.163 z"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M177.801,441.371l0.019,1.247c0,0,20.216,8.237,20.476,12.246l-39.951,0.291 l0.451-13.975C164.755,444.028,170.973,444.308,177.801,441.371z"
    }
  })])])])])])])])])])])])]), _c('g', {
    staticStyle: {
      "opacity": "0.6"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M162.871,445.617c-0.772,0.228-1.3,1.145-1.115,1.965 c0.185,0.82,1.068,1.392,1.843,1.179c0.775-0.213,1.442-1.294,1.171-2.087 c-0.271-0.793-1.343-1.406-2.047-1.003"
    }
  })])])])])])])])])])])])])]), _c('g', {
    staticStyle: {
      "opacity": "0.6"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M158.345,455.155l0.109-3.361l38.251,0.952c0,0,1.784,0.8,1.592,2.118 L158.345,455.155z"
    }
  })])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M177.96,442.735c-0.005,0.205-0.98,0.305-1.935,0.971 c-0.972,0.64-1.461,1.531-1.641,1.452c-0.18-0.038,0.103-1.266,1.273-2.051 C176.82,442.31,178.001,442.547,177.96,442.735z"
    }
  })])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M182.163,444.526c0.046,0.198-0.797,0.553-1.454,1.425 c-0.681,0.852-0.842,1.79-1.036,1.783c-0.183,0.033-0.326-1.166,0.51-2.234 C181.01,444.425,182.157,444.33,182.163,444.526z"
    }
  })])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M184.577,449.779c-0.177,0.045-0.455-0.977,0.038-2.104 c0.486-1.13,1.403-1.58,1.487-1.41c0.111,0.168-0.477,0.775-0.869,1.706 C184.821,448.893,184.771,449.758,184.577,449.779z"
    }
  })])])])])])])])])])])])])])])])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M147.84,249.356c0,0,10.141,45.452,18.711,97.864c7.048,43.106,10.168,89.776,10.168,89.776 l-20.757,1.216c0,0-12.647-53.457-22.496-91.889c-9.083-35.442-16.47-54.037-16.47-54.037l-4.158-46.771L147.84,249.356z"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M90.573,240.31c0,0-18.207,24.612-16.675,50.301c0.916,15.369,30.173,146.384,30.173,146.384 h21.509l-7.099-140.148l6.243-47.492L90.573,240.31z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M146.45,174.077c0.021-0.001,0.053,0.261,0.097,0.762c0.042,0.563,0.096,1.291,0.163,2.194 c0.146,1.906,0.246,4.67,0.312,8.087c0.127,6.835-0.192,16.28-0.876,26.677c-0.681,10.402-1.27,19.812-1.401,26.635 c-0.076,3.41-0.102,6.172-0.077,8.08c-0.001,0.905-0.001,1.635-0.002,2.198c-0.007,0.503-0.021,0.768-0.041,0.768 c-0.021,0.001-0.047-0.262-0.079-0.764c-0.028-0.563-0.064-1.293-0.11-2.197c-0.096-1.909-0.134-4.675-0.112-8.092 c0.023-6.837,0.547-16.268,1.228-26.665c0.683-10.394,1.067-19.814,1.049-26.637c-0.012-3.411-0.048-6.173-0.123-8.079 c-0.021-0.905-0.038-1.635-0.051-2.198C146.423,174.343,146.43,174.078,146.45,174.077z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffbf9d"
    },
    attrs: {
      "d": "M207.447,175.416l-11.102,4.079l-12.124,16.414l3.311,5.739l3.275-3.076 c0,0,12.487-2.324,13.378-4.104c0.892-1.78-0.124-3.3-0.124-3.3s0.528-1.95,0.1-3.463c-0.428-1.513-1.569-1.725-1.569-1.725 s1.371-0.564,0.786-2.311c-0.585-1.747-1.803-2.076-1.803-2.076s7.448-3.544,8.109-4.548c0.231-0.351,0.14-0.698-0.076-1 C209.117,175.358,208.223,175.131,207.447,175.416z"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffbf9d"
    },
    attrs: {
      "d": "M182.315,192.484l2.243-3.145l4.842-8.781l10.79-2.908c0,0,1.816,0.85-0.694,4.069 c-2.51,3.219-6.026,2.566-6.026,2.566s0.767,7.003-1.139,10.13c-1.906,3.127-7.05,3.399-7.05,3.399L182.315,192.484z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff9a6c"
    },
    attrs: {
      "d": "M192.456,194.909c0.021,0.014,0.203-0.222,0.473-0.694c0.271-0.471,0.605-1.193,0.888-2.139 c0.575-1.864,0.814-4.771-0.3-7.648l-0.171,0.315c0.122-0.02,0.254-0.042,0.386-0.063c1.467-0.24,2.894-0.554,4.076-1.19 c1.194-0.609,2.044-1.606,2.459-2.554c0.434-0.954,0.463-1.85,0.342-2.417c-0.119-0.574-0.31-0.839-0.325-0.829 c-0.039,0.017,0.094,0.306,0.155,0.856c0.063,0.544-0.012,1.37-0.452,2.244c-0.432,0.876-1.223,1.76-2.362,2.319 c-1.125,0.581-2.504,0.877-3.963,1.114c-0.132,0.022-0.263,0.043-0.384,0.063l-0.276,0.046l0.105,0.27 c1.07,2.752,0.898,5.548,0.414,7.386C193.045,193.857,192.379,194.866,192.456,194.909z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff9a6c"
    },
    attrs: {
      "d": "M202.296,186.331c-0.015-0.032-0.395,0.142-1.104,0.397c-0.706,0.265-1.742,0.6-3.008,1.092 c-0.629,0.253-1.326,0.543-2.014,0.999c-0.337,0.229-0.713,0.528-0.896,1.014c-0.188,0.486-0.065,1.061,0.21,1.476 c0.271,0.426,0.663,0.764,1.133,0.972c0.478,0.225,1.047,0.185,1.517,0.087c0.242-0.044,0.476-0.091,0.712-0.123 c0.262-0.037,0.509-0.102,0.755-0.174c0.491-0.145,0.972-0.324,1.456-0.511c0.441-0.173,0.877-0.344,1.287-0.504 l-0.141-0.436c-0.947,0.342-1.716,0.898-2.461,1.401c-0.368,0.252-0.73,0.5-1.084,0.743 c-0.346,0.238-0.726,0.416-1.07,0.711c-0.341,0.282-0.614,0.727-0.608,1.206c-0.002,0.237,0.078,0.486,0.226,0.668 c0.147,0.181,0.334,0.294,0.513,0.373c0.718,0.279,1.409,0.316,2.029,0.275c1.241-0.111,2.167-0.497,2.794-0.744 c0.626-0.263,0.957-0.435,0.948-0.461c-0.011-0.03-0.364,0.089-1.002,0.301c-0.638,0.197-1.571,0.529-2.756,0.593 c-0.584,0.022-1.251-0.043-1.873-0.302c-0.303-0.134-0.518-0.372-0.504-0.701c0.004-0.332,0.191-0.652,0.483-0.888 c0.284-0.242,0.67-0.422,1.037-0.666c0.359-0.241,0.726-0.487,1.1-0.737c0.74-0.493,1.512-1.032,2.362-1.334l-0.141-0.436 c-0.412,0.161-0.85,0.332-1.293,0.504c-0.478,0.185-0.952,0.362-1.421,0.502c-0.234,0.069-0.469,0.131-0.694,0.164 c-0.252,0.035-0.495,0.086-0.73,0.13c-0.47,0.096-0.895,0.124-1.281-0.05c-0.388-0.164-0.731-0.455-0.954-0.799 c-0.229-0.343-0.312-0.751-0.185-1.097c0.121-0.35,0.421-0.617,0.734-0.837c0.641-0.444,1.312-0.746,1.927-1.015 c1.238-0.526,2.266-0.91,2.956-1.228C201.949,186.587,202.309,186.357,202.296,186.331z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff9a6c"
    },
    attrs: {
      "d": "M201.459,181.682c-0.015-0.052-0.923,0.163-2.292,0.803 c-0.683,0.321-1.475,0.756-2.309,1.319c-0.416,0.282-0.842,0.597-1.268,0.944c-0.407,0.346-0.947,0.754-1.037,1.516 c-0.031,0.374,0.15,0.741,0.392,0.962c0.241,0.233,0.549,0.358,0.835,0.412c0.579,0.101,1.103,0.036,1.6-0.022 c0.988-0.139,1.855-0.354,2.576-0.559c1.444-0.407,2.283-0.845,2.256-0.904c-0.024-0.057-0.884,0.265-2.331,0.587 c-0.721,0.162-1.587,0.342-2.548,0.453c-0.476,0.047-0.993,0.092-1.47,0.001c-0.463-0.077-0.903-0.445-0.868-0.9 c0.037-0.458,0.462-0.865,0.863-1.191c0.413-0.344,0.824-0.659,1.225-0.945c0.804-0.57,1.565-1.026,2.22-1.379 C200.614,182.075,201.482,181.752,201.459,181.682z"
    }
  })])])])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M161.779,201.596l-11.135-35.702c-1.02-3.27-3.51-5.809-6.665-6.795l-6.801-1.54l7.524,57.956 l1.685,4.349c3.978,8.868,12.687,7.368,20.364,3.451c0.276-0.141,0.545-0.287,0.805-0.437l22.466-18.1l-7.431-13.389 L161.779,201.596z"
    }
  })])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M159.297,211.787c0.137,0.005,0.183-2.376,0.942-5.167c0.737-2.799,1.88-4.859,1.76-4.929 c-0.085-0.069-1.428,1.932-2.186,4.804C159.036,209.361,159.19,211.801,159.297,211.787z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M91.913,176.073l7.525,70.221l41.678,3.062l3.321-2.839l-1.155-53.024l-14.97-37.765l0,0 c-1.781,3.378-5.192,4.522-9.306,4.207c-2.803-0.215-5.469-1.3-7.75-2.943l-6.887-4.958L91.913,176.073z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M104.462,148.422l-6.676,7.307l-22.35,7.537l13.958,67.495l-10.63,26.123 c-1.119,2.749-2.049,5.572-2.784,8.447l-6.548,25.623c0,0,22.55,6.139,28.353,2.79c5.802-3.349,12.894-35.937,15.043-43.673 c2.149-7.736,5.372-30.731,3.868-42.98c-1.504-12.249-4.083-30.301-5.373-36.533 C110.036,164.325,104.462,148.422,104.462,148.422z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M75.437,163.266c0,0-5.86,7.664-7.521,15.028c-2.807,12.439-13.652,46.388-13.007,54.34 c0.645,7.951,42.663,22.379,42.663,22.379l1.719-22.135l-19.547-10.302l5.364-20.858"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M85.108,201.717c0.008,0.002-0.015,0.125-0.068,0.365 c-0.061,0.261-0.143,0.613-0.249,1.063c-0.236,0.96-0.574,2.336-1.009,4.109c-0.908,3.606-2.221,8.821-3.868,15.365 l-0.088-0.198c5.473,2.867,12.115,6.345,19.573,10.251l0.135,0.071l-0.012,0.152c-0.513,6.723-1.083,14.201-1.689,22.137 l-0.026,0.341l-0.321-0.113c-8.232-2.897-17.101-6.277-26.034-10.423c-2.936-1.383-5.815-2.808-8.55-4.409 c-2.697-1.632-5.444-3.255-7.394-5.764c-0.259-0.299-0.418-0.68-0.604-1.037c-0.111-0.169-0.116-0.395-0.177-0.59 c-0.047-0.203-0.105-0.408-0.085-0.598c0.017-0.771-0.033-1.551,0.083-2.296c0.128-1.511,0.4-2.976,0.641-4.432 c0.569-2.892,1.19-5.706,1.871-8.433c2.708-10.91,5.582-20.609,7.838-28.795c1.147-4.091,2.105-7.798,2.913-11.083 c0.908-3.277,2.247-5.894,3.39-7.973c1.155-2.081,2.194-3.612,2.908-4.639c0.359-0.513,0.645-0.895,0.84-1.149 c0.196-0.254,0.311-0.373,0.311-0.373s-0.084,0.142-0.265,0.406c-0.192,0.285-0.456,0.677-0.794,1.179 c-0.683,1.045-1.69,2.591-2.811,4.679c-1.11,2.086-2.413,4.706-3.281,7.95c-0.775,3.274-1.713,7.013-2.835,11.106 c-2.208,8.202-5.044,17.913-7.721,28.812c-0.673,2.723-1.287,5.531-1.847,8.409c-0.236,1.445-0.504,2.902-0.627,4.383 c-0.115,0.742-0.06,1.475-0.079,2.216c0.036,0.708,0.317,1.355,0.77,1.947c1.822,2.35,4.561,4,7.231,5.604 c2.714,1.587,5.582,3.006,8.508,4.384c8.902,4.132,17.765,7.52,25.971,10.425l-0.346,0.228 c0.627-7.934,1.218-15.41,1.749-22.132l0.123,0.223c-7.438-3.945-14.062-7.458-19.52-10.353l-0.123-0.065l0.035-0.133 c1.714-6.527,3.079-11.728,4.023-15.325c0.474-1.763,0.842-3.132,1.098-4.086c0.125-0.445,0.222-0.793,0.295-1.051 C85.06,201.834,85.1,201.715,85.108,201.717z"
    }
  })])])])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#455a64"
    },
    attrs: {
      "d": "M128.343,150.866l3.283,5.088l13.693,3.461c0,0,3.603,18.037,3.603,22.98 c0,4.943-2.038,59.733-2.038,62.312c0,2.579,9.885,37.607,9.026,39.756c-0.86,2.149-11.175,3.653-11.175,3.653 s-3.868-30.301-3.868-40.616c0-10.315-0.43-35.673-2.579-48.137c-2.149-12.464-9.886-43.41-9.886-43.41L128.343,150.866z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M141.098,253.26c-0.009,0-0.016-0.087-0.02-0.257c-0.001-0.202-0.002-0.45-0.003-0.753 c0.01-0.707,0.024-1.673,0.041-2.894c0.058-2.561,0.141-6.184,0.242-10.64c0.21-8.984,0.573-21.395,0.796-35.1 c0.016-1.713,0.04-3.407,0.025-5.072c0.009-1.651-0.174-3.286-0.298-4.901c-0.259-3.223-0.516-6.329-0.816-9.281 c-0.3-2.952-0.638-5.752-1.081-8.348c-0.436-2.594-1.193-4.925-2.004-7.013c-1.639-4.17-3.331-7.396-4.503-9.613 c-0.583-1.071-1.045-1.919-1.383-2.539c-0.145-0.266-0.264-0.483-0.361-0.66c-0.079-0.15-0.117-0.229-0.109-0.234 c0.008-0.005,0.062,0.064,0.157,0.205c0.11,0.17,0.244,0.378,0.408,0.633c0.35,0.562,0.856,1.397,1.475,2.493 c1.232,2.19,2.98,5.395,4.677,9.574c0.838,2.087,1.63,4.456,2.091,7.075c0.466,2.611,0.821,5.418,1.135,8.375 c0.315,2.957,0.583,6.067,0.849,9.29c0.126,1.607,0.314,3.247,0.308,4.939c0.017,1.675-0.006,3.369-0.022,5.085 c-0.224,13.715-0.648,26.122-0.958,35.104c-0.174,4.455-0.316,8.076-0.416,10.636c-0.061,1.219-0.109,2.185-0.144,2.891 c-0.021,0.303-0.038,0.549-0.052,0.751C141.12,253.174,141.108,253.261,141.098,253.26z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M115.625,232.633c-0.019,0.002-0.063-0.275-0.121-0.806c-0.056-0.53-0.124-1.314-0.19-2.325 c-0.125-2.021-0.248-4.953-0.188-8.576c0.028-1.811,0.104-3.796,0.241-5.922c0.086-2.092-0.3-4.332-0.806-6.652 c-1.122-4.629-2.905-9.581-4.944-14.699c-2.068-5.113-4.21-9.913-6.195-14.264c-0.965-2.184-2.015-4.214-2.646-6.281 c-0.637-2.047-1.05-3.992-1.402-5.77c-0.689-3.56-1.064-6.468-1.308-8.477c-0.118-1.005-0.198-1.787-0.243-2.319 c-0.045-0.531-0.057-0.811-0.038-0.813c0.019-0.002,0.067,0.274,0.148,0.8c0.087,0.578,0.201,1.344,0.345,2.303 c0.309,1.997,0.742,4.893,1.477,8.429c0.374,1.765,0.808,3.697,1.455,5.708c0.63,2.005,1.692,4.026,2.672,6.208 c2.011,4.342,4.172,9.145,6.245,14.27c2.044,5.133,3.821,10.108,4.927,14.789c0.497,2.351,0.877,4.624,0.767,6.798 c-0.156,2.118-0.254,4.093-0.307,5.899c-0.109,3.611-0.046,6.537,0.014,8.557c0.036,0.969,0.065,1.743,0.087,2.327 C115.637,232.351,115.644,232.631,115.625,232.633z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M177.266,230.941l-11.732,15.858c-0.488,0.66-1.311,0.982-2.117,0.83l-50.749-9.591 c-1.267-0.239-2.036-1.537-1.637-2.763l5.475-16.855c0.332-1.021,1.369-1.639,2.425-1.443l57.007,10.588 C177.491,227.853,178.206,229.67,177.266,230.941z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M67.916,223.962c-0.042-0.044,0.526-0.683,1.705-1.378c1.165-0.695,2.997-1.385,5.105-1.413 c2.109-0.029,3.959,0.611,5.143,1.274c1.198,0.663,1.783,1.286,1.742,1.331c-0.055,0.072-0.718-0.433-1.916-0.984 c-1.188-0.553-2.961-1.099-4.961-1.071c-1.999,0.027-3.756,0.621-4.929,1.206C68.622,223.51,67.972,224.033,67.916,223.962 z"
    }
  })])])])]), _c('g', {
    staticStyle: {
      "opacity": "0.3"
    }
  }, [_c('g', [_c('g', [_c('polygon', {
    attrs: {
      "points": "79.923,254.041 99.973,261.414 102.062,253.094 111.558,255.012 112.839,250.204 97.935,248.115 &#10;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;97.787,255.012 82.209,249.133 &#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffbf9d"
    },
    attrs: {
      "d": "M99.154,234.648c0,0,4.011-3.388,5.252-4.152c1.242-0.764,5.444-3.534,7.354-3.247 c1.91,0.286,1.91,0.286,1.91,0.286l-1.719,5.062c0,0,15.376-2.292,17.478,0.191c2.101,2.483-2.292,2.961-4.584,3.247 c-2.292,0.287-9.657,1.528-9.657,1.528s19.207-2.101,20.544,0c1.337,2.101-1.864,2.579-1.864,2.579l-12.722,5.062 l-1.459,0.573l-1.461,1.91c0,0-5.224,3.629-6.848,3.152c-1.623-0.478-13.443-2.724-13.443-2.724L99.154,234.648z"
    }
  })])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff9a6c"
    },
    attrs: {
      "d": "M112.51,243.329c-0.018-0.069,1.113-0.442,2.979-0.908 c1.865-0.467,4.471-1.006,7.379-1.414c2.909-0.406,5.563-0.603,7.485-0.667c1.922-0.064,3.112-0.016,3.113,0.055 c0.002,0.081-1.182,0.17-3.09,0.333c-1.908,0.162-4.54,0.42-7.432,0.823c-2.891,0.406-5.491,0.882-7.371,1.249 C113.694,243.167,112.531,243.407,112.51,243.329z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ff9a6c"
    },
    attrs: {
      "d": "M114.257,247.027c-0.038-0.147,1.194-0.594,2.752-0.999 c1.558-0.405,2.852-0.614,2.89-0.467c0.038,0.147-1.194,0.594-2.752,0.999 C115.589,246.965,114.295,247.174,114.257,247.027z"
    }
  })])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M148.574,174.874c0.019-0.001,0.049,0.241,0.09,0.704c0.039,0.52,0.088,1.193,0.15,2.028 c0.135,1.761,0.228,4.315,0.289,7.472c0.117,6.316-0.178,15.042-0.809,24.649c-0.629,9.611-1.173,18.305-1.294,24.61 c-0.07,3.151-0.094,5.703-0.071,7.466c-0.001,0.836-0.001,1.51-0.002,2.031c-0.007,0.465-0.019,0.709-0.038,0.71 c-0.019,0.001-0.044-0.242-0.073-0.706c-0.026-0.521-0.06-1.194-0.102-2.03c-0.089-1.764-0.124-4.319-0.103-7.476 c0.021-6.317,0.505-15.031,1.134-24.638c0.631-9.604,0.986-18.307,0.969-24.612c-0.011-3.152-0.045-5.703-0.114-7.465 c-0.02-0.836-0.035-1.51-0.047-2.031C148.548,175.119,148.555,174.875,148.574,174.874z"
    }
  })])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M86.641,199.521c-0.038-0.001-0.068-0.505-0.09-1.414c-0.013-0.908-0.069-2.222-0.182-3.84 c-0.219-3.235-0.802-7.692-2.074-12.473c-1.284-4.78-3.004-8.933-4.428-11.846c-0.71-1.458-1.317-2.625-1.759-3.418 c-0.434-0.798-0.66-1.25-0.627-1.27c0.032-0.02,0.319,0.394,0.812,1.162c0.5,0.763,1.162,1.907,1.921,3.351 c1.523,2.885,3.317,7.056,4.612,11.879c1.284,4.824,1.81,9.333,1.931,12.593c0.063,1.631,0.06,2.952,0.008,3.863 C86.721,199.02,86.679,199.522,86.641,199.521z"
    }
  })])])])])])])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#263238"
    },
    attrs: {
      "d": "M125.092,136.902c0.058,0.037-0.57,0.603-1.796,0.558c-0.589-0.025-1.346-0.167-1.985-0.731 c-0.64-0.557-0.956-1.503-0.922-2.421c0.007-0.242,0.021-0.436,0.074-0.702c0.072-0.244,0.158-0.437,0.292-0.647 c0.036-0.053,0.072-0.104,0.136-0.164c0.074-0.069,0.162-0.109,0.236-0.129c0.16-0.043,0.302-0.024,0.418,0.001 c0.234,0.059,0.392,0.127,0.578,0.186c0.657,0.234,1.287,0.458,1.895,0.674c1.074,0.398,1.727,0.679,1.705,0.747 c-0.022,0.068-0.715-0.088-1.818-0.397c-0.619-0.182-1.26-0.371-1.929-0.568c-0.176-0.051-0.381-0.124-0.532-0.156 c-0.077-0.016-0.141-0.015-0.176-0.003l-0.024,0.01l-0.003,0.001l-0.001,0.001l-0.001,0c0.009,0.016-0.081-0.14-0.041-0.071 l0.032,0.053c0.027,0.031,0.008,0.007,0.01,0.02c-0.011,0.01-0.036,0.042-0.057,0.075c-0.087,0.137-0.171,0.333-0.216,0.497 c-0.028,0.15-0.053,0.389-0.055,0.583c-0.026,0.819,0.229,1.591,0.729,2.059c0.49,0.471,1.15,0.651,1.684,0.715 C124.427,137.227,125.058,136.829,125.092,136.902z"
    }
  })])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }